import React, { useState, useEffect } from 'react';
import { Modal, Button } from 'react-bootstrap';
import "../result/result.css";
import AlertMessage from "../../AlertMessage";
import { db, ref, set } from '../firebase';
import resultBackground from '../../assets/images/Result6.png';
import resultTermFirst from '../../assets/images/FirstTerm.jpg';
import resultTermFirst1 from '../../assets/images/FirstTerm1.jpg';


const CbseResult = () => {
  const [academicYear, setAcademicYear] = useState('');
  const [classValue, setClassValue] = useState('');
  const [selectedExamName, setSelectedExamName] = useState('');
  const [studentData, setStudentData] = useState([]);
  const [selectedStudents, setSelectedStudents] = useState([]);
  const [marksData, setMarksData] = useState({});
  const [classes, setClasses] = useState([]);
  const [selectedStudentResults, setSelectedStudentResults] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [schoolName, setSchoolName] = useState('');
  const [schoolLogo, setSchoolLogo] = useState('');
  const [sansthaName, setSansthaName] = useState('');
  const [taluka, setTaluka] = useState('');
  const [jilha, setJilha] = useState('');
  const [mobileNumber, setMobileNumber] = useState('');
  const [division, setDivision] = useState("");
  const [divisions, setDivisions] = useState([]);
  const udiseNumber = localStorage.getItem("udiseNumber");
  const examNames = ['Semester First', 'Semester Second'];
  const [previousYearClass, setPreviousYearClass] = useState('');

  const examNameTranslations = {
    "Semester First": "प्रथम सत्र",
    "Semester Second": "द्वितीय सत्र",
  };

  const [language, setLanguage] = useState(localStorage.getItem('language') || 'English');

  const [alertMessage, setAlertMessage] = useState("");
  const [showAlert, setShowAlert] = useState(false);


  const [subjectSequence, setSubjectSequence] = useState([]); // New state for subject sequence


  // Update your fetchSubjectSequence function
  const fetchSubjectSequence = async () => {
    try {
      const classToUse = previousYearClass || classValue;
      const response = await fetch(
        `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/subjectSequence/icse/${academicYear}/${classToUse}/${division}.json`
      );

      if (!response.ok) {
        throw new Error('Failed to fetch subject sequence');
      }

      const data = await response.json();

      // Convert the object to an ordered array
      const orderedSubjects = Object.entries(data)
        .sort(([a], [b]) => parseInt(a) - parseInt(b)) // Sort by numeric keys
        .map(([_, subject]) => subject); // Extract subject names

      setSubjectSequence(orderedSubjects);
      console.log('Fetched subject sequence:', orderedSubjects);
    } catch (error) {
      console.error('Error fetching subject sequence:', error);
      // Fallback to default subjects if sequence not found
      setSubjectSequence(['English', 'Hindi', 'Maths']);
    }
  };

  // Update your useEffect hook
  useEffect(() => {
    if (academicYear && (classValue || previousYearClass) && division) {
      fetchSubjectSequence();
    }
  }, [academicYear, classValue, division, previousYearClass]);

  useEffect(() => {
    const fetchDefaultSettings = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/defaultSettings.json`);
        if (response.ok) {
          const data = await response.json();

          if (data) {
            setAcademicYear(data.defaultYear || "");
          }
        } else {
          console.error("Failed to fetch default settings.");
        }
      } catch (error) {
        console.error("Error fetching default settings:", error);
      }
    };

    fetchDefaultSettings();
  }, [udiseNumber]);
  useEffect(() => {
    if (alertMessage) {
      setShowAlert(true);
      const timeoutId = setTimeout(() => {
        setShowAlert(false);
        setAlertMessage("");
      }, 3000);
      return () => clearTimeout(timeoutId);
    }
  }, [alertMessage]);


  useEffect(() => {
    const storedLanguage = localStorage.getItem('language') || 'English';
    setLanguage(storedLanguage);
  }, []);

  const fetchSchoolName = async () => {
    try {
      const db = await openDB();
      const transaction = db.transaction(SCHOOL_STORE, 'readonly');
      const store = transaction.objectStore(SCHOOL_STORE);

      // Get the school data using the udiseNumber as key
      const request = store.get(udiseNumber);

      request.onsuccess = (event) => {
        const schoolData = event.target.result;
        if (schoolData) {
          // Set school name and logo from IndexedDB
          setSchoolName(schoolData.schoolName || '-');
          setSchoolLogo(schoolData.schoolLogo || '');
          setSansthaName(schoolData.sansthaName || '');
          setMobileNumber(schoolData.mobileNumber || '');
          setMobileNumber(schoolData.mobileNumber || '');

          setJilha(schoolData.jilha || '');
          setTaluka(schoolData.taluka || '')

          // Update language if available in school data
          if (schoolData.language) {
            setLanguage(schoolData.language);
            localStorage.setItem('language', schoolData.language);
          }
        } else {
          console.log('No school data found in IndexedDB');
          // Fallback to empty values if no data found
          setSchoolName('-');
          setSchoolLogo('');
        }
      };

      request.onerror = (event) => {
        console.error('Error fetching school data from IndexedDB:', event.target.error);
        // Fallback to empty values on error
        setSchoolName('-');
        setSchoolLogo('');
      };
    } catch (error) {
      console.error('Error accessing IndexedDB:', error);
      // Fallback to empty values on error
      setSchoolName('-');
      setSchoolLogo('');
    }
  };
  useEffect(() => {
    fetchSchoolName();
    fetchStudentData();
  }, [udiseNumber]); // Add udiseNumber as dependency


  useEffect(() => {
    if (selectedExamName && classValue && academicYear) {
      fetchMarksForSelectedSubject();
    }
  }, [selectedExamName, classValue, academicYear]);

  const handleAcademicYearChange = (e) => setAcademicYear(e.target.value);

  const handleExamNameChange = (e) => {
    setSelectedExamName(e.target.value);
    fetchMarksForSelectedSubject(); // Add this line
  }
  // IndexedDB constants
  const DB_NAME = 'SchoolManagementDB';
  const STUDENT_STORE = 'studentData';
  const DB_VERSION = 1;
  const ATTENDANCE_STORE = 'attendance';
  const SCHOOL_STORE = 'schoolData';


  const openDB = () => {
    return new Promise((resolve, reject) => {
      const request = indexedDB.open(DB_NAME, DB_VERSION);

      request.onerror = (event) => {
        console.error("IndexedDB error:", event.target.error);
        reject(event.target.error);
      };

      request.onsuccess = (event) => {
        const db = event.target.result;
        if (!db) {
          console.error("Error: db object is not initialized");
          reject("Error: db object is not initialized");
        } else {
          resolve(db);
        }
      };

      request.onupgradeneeded = (event) => {
        const db = event.target.result;

        // Create object stores if they don't exist
        if (!db.objectStoreNames.contains(STUDENT_STORE)) {
          db.createObjectStore(STUDENT_STORE, { keyPath: "id" });
        }

        // Add SCHOOL_STORE if it doesn't exist
        if (!db.objectStoreNames.contains(SCHOOL_STORE)) {
          db.createObjectStore(SCHOOL_STORE, { keyPath: "udiseNumber" });
        }

      };
    });
  };


  // Function to fetch student data from IndexedDB
  const fetchStudentData = async () => {
    try {
      const db = await openDB();
      if (!db) {
        console.error("Error: db object is not initialized");
        return;
      }

      const transaction = db.transaction(STUDENT_STORE, "readonly");
      const store = transaction.objectStore(STUDENT_STORE);
      const request = store.getAll();

      request.onsuccess = (event) => {
        const allStudents = event.target.result;

        // Filter out students where isActive is false
        const activeStudents = allStudents.filter(student =>
          student.isActive !== false
        );

        const classesAndDivisions = {};
        activeStudents.forEach((student) => {
          if (student && student.currentClass) {
            if (!classesAndDivisions[student.currentClass]) {
              classesAndDivisions[student.currentClass] = {};
            }

            const division = student.division || "";
            if (!classesAndDivisions[student.currentClass][division]) {
              classesAndDivisions[student.currentClass][division] = [];
            }

            // Use the ID as the serial number equivalent 
            classesAndDivisions[student.currentClass][division].push(student.id);
          }
        });

        // Extract class, division, and srNo from key 
        const updatedStudents = activeStudents.map((student) => {
          const keyParts = student.id.split("-"); // Split by "-" 
          const className = keyParts[0]; // First part is class 
          const division = keyParts[1]; // Second part is division 
          const srNo = keyParts[keyParts.length - 1]; // Last part is srNo 
          return { ...student, className, division, srNo };
        });

        setClasses(Object.keys(classesAndDivisions));
        setStudentData(updatedStudents); // Store updated students 
      };

      request.onerror = (event) => {
        console.error("Error fetching student data from IndexedDB:", event.target.error);
      };
    } catch (error) {
      console.error("Error fetching student data:", error);
    }
  };

  const fetchDivisionsForClass = async (classValue) => {
    try {
      const db = await openDB();
      const transaction = db.transaction(STUDENT_STORE, "readonly");
      const store = transaction.objectStore(STUDENT_STORE);
      const request = store.getAll(); // Fetch all students

      request.onsuccess = (event) => {
        const students = event.target.result;
        const divisionsForClass = new Set();

        students.forEach((student) => {
          if (student.currentClass === classValue) {
            divisionsForClass.add(student.division);
          }
        });

        setDivisions(Array.from(divisionsForClass)); // Update divisions state
      };

      request.onerror = (event) => {
        console.error("Error fetching divisions from IndexedDB:", event.target.error);
      };
    } catch (error) {
      console.error("Error opening IndexedDB:", error);
    }
  };

  // Load student data and marks from IndexedDB
  useEffect(() => {
    const loadData = async () => {
      try {
        const db = await openDB();
        await fetchStudentData(db);
      } catch (error) {
        console.error("Error loading data from IndexedDB:", error);
      }
    };

    loadData();
  }, []);


  const handleClassChange = async (e) => {
    const selectedClass = e.target.value;
    setClassValue(selectedClass); // Update the class value
    setDivision(""); // Reset division when class changes
    fetchSubjectsForClass(e.target.value);

    if (selectedClass) {
      await fetchDivisionsForClass(selectedClass);
    }

    // Filter students based on the selected class
    const filteredStudents = studentData.filter((student) => student.currentClass === selectedClass);
    setSelectedStudents(filteredStudents);
  };


  const fetchSubjectsForClass = async (classValue) => {
    try {
      if (!academicYear) {
        console.error('Academic year is not set');
        return;
      }
    } catch (error) {
      console.error(`Error fetching subjects for class ${classValue} and academic year ${academicYear}:`, error);
    }
  };

  // const fetchMarksForSelectedSubject = async () => {
  //   try {
  //     const selectedStudents = studentData.filter(
  //       (student) => student.currentClass === classValue
  //     );
  //     setSelectedStudents(selectedStudents);
  //     const marksDataPromises = selectedStudents.map(async (student) => {
  //       const studentMarks = await fetchMarksData(
  //         student.srNo,
  //         academicYear,
  //         selectedExamName
  //       );
  //       return { srNo: student.srNo, marks: studentMarks };
  //     });

  //     const marksDataArray = await Promise.all(marksDataPromises);
  //     const marksData = marksDataArray.reduce((acc, { srNo, marks }) => {
  //       acc[srNo] = marks;
  //       return acc;
  //     }, {});

  //     setMarksData(marksData);
  //   } catch (error) {
  //     console.error('Error fetching marks data:', error);
  //   }
  // };
  const fetchMarksForSelectedSubject = async () => {
    try {
      let filteredStudents;

      if (division === "") {
        // Show all students from the selected class if no division is selected
        filteredStudents = studentData.filter(
          (student) => student.currentClass === classValue
        );
      } else {
        // Filter by both class and division
        filteredStudents = studentData.filter(
          (student) =>
            student.currentClass === classValue &&
            student.division === division
        );
      }

      setSelectedStudents(filteredStudents);

      const marksDataPromises = filteredStudents.map(async (student) => {
        const studentMarks = await fetchMarksData(
          student.srNo,
          academicYear,
          selectedExamName
        );
        return { srNo: student.srNo, marks: studentMarks };
      });

      const marksDataArray = await Promise.all(marksDataPromises);
      const marksData = marksDataArray.reduce((acc, { srNo, marks }) => {
        acc[srNo] = marks;
        return acc;
      }, {});

      setMarksData(marksData);
    } catch (error) {
      console.error('Error fetching marks data:', error);
    }
  };

  const fetchMarksData = async (studentId, academicYear, examType) => {
    try {
      const db = await openDB();
      const transaction = db.transaction(STUDENT_STORE, "readonly");
      const store = transaction.objectStore(STUDENT_STORE);
      const request = store.get(studentId);

      return new Promise((resolve, reject) => {
        request.onsuccess = (event) => {
          const studentData = event.target.result;

          if (!studentData || !studentData.cbseResult) {
            console.warn('No CBSE result data found for student');
            resolve(null);
            return;
          }

          const academicYearData = studentData.cbseResult[academicYear];
          if (!academicYearData) {
            console.warn(`No data found for academic year: ${academicYear}`);
            resolve(null);
            return;
          }

          const result = {
            studentInfo: {
              name: studentData.stdName,
              surname: studentData.stdSurname,
              class: studentData.currentClass,
              division: studentData.division,
              rollNo: studentData.rollNo
            }
          };

          if (examType === 'Semester First') {
            result.unitTestI = academicYearData['Unit Test I'] || {};
            result.unitTestII = academicYearData['Unit Test II'] || {};
            result.unitTestIII = academicYearData['Unit Test III'] || {};
            result.semester = academicYearData['Semester First'] || {};
          } else if (examType === 'Semester Second') {

            result.unitTestIV = academicYearData['Unit Test IV'] || {};
            result.unitTestV = academicYearData['Unit Test V'] || {};
            result.unitTestVI = academicYearData['Unit Test VI'] || {};
            result.semester = academicYearData['Semester Second'] || {};
          }

          console.log('Fetched marks data:', result);
          resolve(result);
        };

        request.onerror = (event) => {
          console.error("Error fetching marks:", event.target.error);
          reject(event.target.error);
        };
      });
    } catch (error) {
      console.error('Error in fetchMarksData:', error);
      return null;
    }
  };




  const [selectedStudentForSr, setSelectedStudentForSr] = useState('')


  const fetchHeightWeightData = async (srNo, academicYear) => {
    try {
      const db = await openDB();
      const transaction = db.transaction(STUDENT_STORE, "readonly");
      const store = transaction.objectStore(STUDENT_STORE);

      const request = store.get(srNo); // Fetch student data by srNo

      return new Promise((resolve, reject) => {
        request.onsuccess = (event) => {
          const studentData = event.target.result;

          if (!studentData || !studentData.weightandHeight) {
            console.warn('No height and weight data found for student');
            resolve(null);
            return;
          }

          const heightWeight = studentData.weightandHeight[academicYear] || {};
          resolve(heightWeight);
        };

        request.onerror = (event) => {
          console.error("Error fetching height and weight from IndexedDB:", event.target.error);
          reject(event.target.error);
        };
      });
    } catch (error) {
      console.error('Error in fetchHeightWeightData:', error);
      return null;
    }
  };

  const viewResult = async (srNo) => {
    try {
      const student = selectedStudents.find((student) => student.srNo === srNo);
      if (!student) {
        throw new Error("Student not found");
      }
      setSelectedStudentForSr(student);

      // Fetch First Semester data
      const firstSemesterData = await fetchMarksData(
        student.id || srNo,
        academicYear,
        'Semester First'
      );

      // Fetch Second Semester data
      const secondSemesterData = await fetchMarksData(
        student.id || srNo,
        academicYear,
        'Semester Second'
      );

      // Fetch height and weight data
      const heightWeightData = await fetchHeightWeightData(student.id || student.srNo, academicYear);

      if (!firstSemesterData || !secondSemesterData) {
        setAlertMessage("Add the subject and fill the marks to view the result.");
        return;
      }



      const results = {
        studentInfo: {
          name: student.stdName,
          father: student.stdFather,
          surname: student.stdSurname,
          class: student.currentClass,
          division: student.division,
          rollNo: student.rollNo,
          dob: student.dob,
          motherTounge: student.motherTounge,
          gender: student.gender,
          stdMother: student.stdMother,
          weightSeptember: heightWeightData?.September?.weight,
          heightSeptember: heightWeightData?.September?.height,

          weightMarch: heightWeightData?.March?.weight,
          heightMarch: heightWeightData?.March?.height
        },

        firstSemester: firstSemesterData,
        secondSemester: secondSemesterData
      };



      // Handle oral skills remarks with fixed defaults to ensure state reset
      const remarksFirst = firstSemesterData?.semester?.Remarks || {};
      const remarksSecond = secondSemesterData?.semester?.Remarks || {};

      if (selectedExamName === 'Semester First') {
        setOralSkillsGrades({
          english: {
            conversation1: remarksFirst.englishOralSkills?.conversation1 || '',
            expressesIdeas1: remarksFirst.englishOralSkills?.expressesIdeas1 || '',
            reading1: remarksFirst.englishOralSkills?.reading1 || ''
          },
          marathi: {
            conversation1: remarksFirst.marathiOralSkills?.conversation1 || '',
            reading1: remarksFirst.marathiOralSkills?.reading1 || '',
            recitation1: remarksFirst.marathiOralSkills?.recitation1 || ''
          },
          maths: {
            clarityOfConcept1: remarksFirst.mathsOralSkills?.clarityOfConcept1 || '',
            recognitionCounting1: remarksFirst.mathsOralSkills?.recognitionCounting1 || '',
            numberFormation1: remarksFirst.mathsOralSkills?.numberFormation1 || ''
          },
          evs: {
            generalAwareness1: remarksFirst.evsOralSkills?.generalAwareness1 || '',
            mySelf1: remarksFirst.evsOralSkills?.mySelf1 || '',
            aboutAnimals1: remarksFirst.evsOralSkills?.aboutAnimals1 || '',
            internalBodyParts1: remarksFirst.evsOralSkills?.internalBodyParts1 || ''
          },
          personality: {
            selfControl1: remarksFirst.personalityDevelopment?.selfControl1 || '',
            respectsOthers1: remarksFirst.personalityDevelopment?.respectsOthers1 || '',
            neatnessCleanliness1: remarksFirst.personalityDevelopment?.neatnessCleanliness1 || '',
            obeyingTeachers1: remarksFirst.personalityDevelopment?.obeyingTeachers1 || ''
          },
          extra: {
            conducts1: remarksFirst.extra?.conducts1 || '',
            teacherRemarks1: remarksFirst.extra?.teacherRemarks1 || '',
          }
        });
      } else if (selectedExamName === 'Semester Second') {
        setOralSkillsGrades({
          english: {
            conversation: remarksSecond.englishOralSkills?.conversation || '',
            expressesIdeas: remarksSecond.englishOralSkills?.expressesIdeas || '',
            reading: remarksSecond.englishOralSkills?.reading || '',
            conversation1: remarksFirst.englishOralSkills?.conversation1 || '',
            expressesIdeas1: remarksFirst.englishOralSkills?.expressesIdeas1 || '',
            reading1: remarksFirst.englishOralSkills?.reading1 || ''
          },
          marathi: {
            conversation: remarksSecond.marathiOralSkills?.conversation || '',
            reading: remarksSecond.marathiOralSkills?.reading || '',
            recitation: remarksSecond.marathiOralSkills?.recitation || '',
            conversation1: remarksFirst.marathiOralSkills?.conversation1 || '',
            reading1: remarksFirst.marathiOralSkills?.reading1 || '',
            recitation1: remarksFirst.marathiOralSkills?.recitation1 || ''
          },
          maths: {
            clarityOfConcept: remarksSecond.mathsOralSkills?.clarityOfConcept || '',
            recognitionCounting: remarksSecond.mathsOralSkills?.recognitionCounting || '',
            numberFormation: remarksSecond.mathsOralSkills?.numberFormation || '',
            clarityOfConcept1: remarksFirst.mathsOralSkills?.clarityOfConcept1 || '',
            recognitionCounting1: remarksFirst.mathsOralSkills?.recognitionCounting1 || '',
            numberFormation1: remarksFirst.mathsOralSkills?.numberFormation1 || ''
          },
          evs: {
            generalAwareness: remarksSecond.evsOralSkills?.generalAwareness || '',
            mySelf: remarksSecond.evsOralSkills?.mySelf || '',
            aboutAnimals: remarksSecond.evsOralSkills?.aboutAnimals || '',
            internalBodyParts: remarksSecond.evsOralSkills?.internalBodyParts || '',
            generalAwareness1: remarksFirst.evsOralSkills?.generalAwareness1 || '',
            mySelf1: remarksFirst.evsOralSkills?.mySelf1 || '',
            aboutAnimals1: remarksFirst.evsOralSkills?.aboutAnimals1 || '',
            internalBodyParts1: remarksFirst.evsOralSkills?.internalBodyParts1 || ''
          },
          personality: {
            selfControl: remarksSecond.personalityDevelopment?.selfControl || '',
            respectsOthers: remarksSecond.personalityDevelopment?.respectsOthers || '',
            neatnessCleanliness: remarksSecond.personalityDevelopment?.neatnessCleanliness || '',
            obeyingTeachers: remarksSecond.personalityDevelopment?.obeyingTeachers || '',
            selfControl1: remarksFirst.personalityDevelopment?.selfControl1 || '',
            respectsOthers1: remarksFirst.personalityDevelopment?.respectsOthers1 || '',
            neatnessCleanliness1: remarksFirst.personalityDevelopment?.neatnessCleanliness1 || '',
            obeyingTeachers1: remarksFirst.personalityDevelopment?.obeyingTeachers1 || ''
          },
          extra: {
            conducts: remarksSecond.extra?.conducts || '',
            teacherRemarks: remarksSecond.extra?.teacherRemarks || '',
            conducts1: remarksFirst.extra?.conducts1 || '',
            teacherRemarks1: remarksFirst.extra?.teacherRemarks1 || '',
          }
        });
      }

      setSelectedStudentResults(results);
      setShowModal(true);
    } catch (error) {
      console.error("Error fetching student results:", error);
      setAlertMessage("Failed to fetch student results. Please try again.");
    }
  };




  const saveGrades = async () => {
    try {
      if (!selectedStudentForSr || !academicYear || !selectedExamName) {
        alert("Please select student, academic year, and exam name.");
        return;
      }

      const fullKey = selectedStudentForSr?.id || selectedStudentForSr?.srNo;
      if (!fullKey) {
        throw new Error("Invalid student key (id or srNo is missing)");
      }

      const studentId = fullKey.toString().split("-").pop();
      console.log("Extracted studentId for Firebase:", studentId);

      const udiseNumber = localStorage.getItem("udiseNumber");
      if (!udiseNumber) {
        throw new Error("UDISE number is not set in localStorage");
      }

      const removeUndefined = (obj) => {
        return Object.fromEntries(
          Object.entries(obj)
            .filter(([_, v]) => v !== undefined)
            .map(([k, v]) => [k, v && typeof v === 'object' ? removeUndefined(v) : v])
        );
      };

      // Prepare remarks for both semesters separately
      const remarksFirst = removeUndefined({
        timestamp: new Date().toISOString(),
        englishOralSkills: {
          conversation1: oralSkillsGrades.english.conversation1,
          expressesIdeas1: oralSkillsGrades.english.expressesIdeas1,
          reading1: oralSkillsGrades.english.reading1
        },
        marathiOralSkills: {
          conversation1: oralSkillsGrades.marathi.conversation1,
          reading1: oralSkillsGrades.marathi.reading1,
          recitation1: oralSkillsGrades.marathi.recitation1
        },
        mathsOralSkills: {
          clarityOfConcept1: oralSkillsGrades.maths.clarityOfConcept1,
          recognitionCounting1: oralSkillsGrades.maths.recognitionCounting1,
          numberFormation1: oralSkillsGrades.maths.numberFormation1
        },
        evsOralSkills: {
          generalAwareness1: oralSkillsGrades.evs.generalAwareness1,
          mySelf1: oralSkillsGrades.evs.mySelf1,
          aboutAnimals1: oralSkillsGrades.evs.aboutAnimals1,
          internalBodyParts1: oralSkillsGrades.evs.internalBodyParts1
        },
        personalityDevelopment: {
          selfControl1: oralSkillsGrades.personality.selfControl1,
          respectsOthers1: oralSkillsGrades.personality.respectsOthers1,
          neatnessCleanliness1: oralSkillsGrades.personality.neatnessCleanliness1,
          obeyingTeachers1: oralSkillsGrades.personality.obeyingTeachers1
        },
        extra: {
          conducts1: oralSkillsGrades.extra.conducts1,
          teacherRemarks1: oralSkillsGrades.extra.teacherRemarks1
        }
      });

      const remarksSecond = removeUndefined({
        timestamp: new Date().toISOString(),
        englishOralSkills: {
          conversation: oralSkillsGrades.english.conversation,
          expressesIdeas: oralSkillsGrades.english.expressesIdeas,
          reading: oralSkillsGrades.english.reading
        },
        marathiOralSkills: {
          conversation: oralSkillsGrades.marathi.conversation,
          reading: oralSkillsGrades.marathi.reading,
          recitation: oralSkillsGrades.marathi.recitation
        },
        mathsOralSkills: {
          clarityOfConcept: oralSkillsGrades.maths.clarityOfConcept,
          recognitionCounting: oralSkillsGrades.maths.recognitionCounting,
          numberFormation: oralSkillsGrades.maths.numberFormation
        },
        evsOralSkills: {
          generalAwareness: oralSkillsGrades.evs.generalAwareness,
          mySelf: oralSkillsGrades.evs.mySelf,
          aboutAnimals: oralSkillsGrades.evs.aboutAnimals,
          internalBodyParts: oralSkillsGrades.evs.internalBodyParts
        },
        personalityDevelopment: {
          selfControl: oralSkillsGrades.personality.selfControl,
          respectsOthers: oralSkillsGrades.personality.respectsOthers,
          neatnessCleanliness: oralSkillsGrades.personality.neatnessCleanliness,
          obeyingTeachers: oralSkillsGrades.personality.obeyingTeachers
        },
        extra: {
          conducts: oralSkillsGrades.extra.conducts,
          teacherRemarks: oralSkillsGrades.extra.teacherRemarks
        }
      });

      // Save to IndexedDB
      const idb = await openDB();
      const transaction = idb.transaction(STUDENT_STORE, 'readwrite');
      const store = transaction.objectStore(STUDENT_STORE);

      const student = await new Promise((resolve, reject) => {
        const request = store.get(fullKey);
        request.onsuccess = () => resolve(request.result);
        request.onerror = () => reject(request.error);
      });

      if (!student) {
        throw new Error(`Student not found in IndexedDB for key: ${fullKey}`);
      }

      // Build academic year data block
      const academicYearData = { ... (student.cbseResult?.[academicYear] || {}) };

      // Update Semester First remarks if we are in First or Second Semester view
      if (selectedExamName === 'Semester First' || selectedExamName === 'Semester Second') {
        academicYearData['Semester First'] = {
          ...(academicYearData['Semester First'] || {}),
          Remarks: remarksFirst
        };
      }

      // Update Semester Second remarks if we are in Second Semester view
      if (selectedExamName === 'Semester Second') {
        academicYearData['Semester Second'] = {
          ...(academicYearData['Semester Second'] || {}),
          Remarks: remarksSecond
        };
      }

      const updatedStudent = {
        ...student,
        cbseResult: {
          ...(student.cbseResult || {}),
          [academicYear]: academicYearData
        }
      };

      await new Promise((resolve, reject) => {
        const request = store.put(updatedStudent);
        request.onsuccess = () => resolve();
        request.onerror = () => reject(request.error);
      });

      // Save to Firebase
      const firebaseBaseRef = `schoolRegister/${udiseNumber}/studentData/${studentId}/cbseResult/${academicYear}`;

      if (selectedExamName === 'Semester First' || selectedExamName === 'Semester Second') {
        const firstSemRef = ref(db, `${firebaseBaseRef}/Semester First/Remarks`);
        await set(firstSemRef, remarksFirst);
      }

      if (selectedExamName === 'Semester Second') {
        const secondSemRef = ref(db, `${firebaseBaseRef}/Semester Second/Remarks`);
        await set(secondSemRef, remarksSecond);
      }

      alert("Grades and remarks saved successfully to both IndexedDB and Firebase!");
    } catch (error) {
      console.error("❌ Error saving grades:", error);
      alert("Failed to save grades: " + error.message);
    }
  };





  const handleCloseModal = () => setShowModal(false);

  const months = ['June', 'July', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec', 'Jan', 'Feb', 'Mar', 'Apr', 'May'];
  const [attendance, setAttendance] = useState({
    Present: {},
    Absent: {},
    Leave: {}
  });

  const fetchAttendanceFromIndexedDB = async (srNo, academicYear) => {
    try {
      console.log('Fetching Attendance Data with:', { srNo, academicYear });

      const db = await openDB();
      const transaction = db.transaction(ATTENDANCE_STORE, "readonly");
      const store = transaction.objectStore(ATTENDANCE_STORE);

      // Find all keys and log them
      const allKeys = await new Promise((resolve, reject) => {
        const keysRequest = store.getAllKeys();
        keysRequest.onsuccess = (event) => {
          const keys = event.target.result;
          console.log('ALL KEYS IN ATTENDANCE STORE:', keys);
          resolve(keys);
        };
        keysRequest.onerror = (event) => reject(event.target.error);
      });

      // Improved key matching with extensive logging
      const matchingKey = allKeys.find(storeKey => {
        const isMatch = typeof storeKey === 'string' &&
          (storeKey === srNo || storeKey === `"${srNo}"` || storeKey.includes(srNo));

        if (isMatch) {
          console.log('MATCHING KEY FOUND:', {
            storeKey,
            srNo,
            match: isMatch
          });
        }
        return isMatch;
      });

      console.log('Matching Attendance Key:', matchingKey);

      if (!matchingKey) {
        console.warn('No matching attendance key found for:', srNo);
        console.warn('Available keys:', allKeys);
        return null;
      }

      const request = store.get(matchingKey);

      return new Promise((resolve, reject) => {
        request.onsuccess = (event) => {
          const attendanceData = event.target.result;

          console.log('RAW ATTENDANCE DATA:', JSON.stringify(attendanceData, null, 2));

          // Extract the year from academic year
          const startYear = academicYear.split('-')[0];
          const endYear = academicYear.split('-')[1];

          // Process the attendance based on the months
          const fetchedAttendance = {
            Present: {},
            Absent: {},
            Leave: {}
          };

          // Define the first and second semester months
          const firstSemesterMonths = ['June', 'July', 'Aug', 'Sep', 'Oct', 'Nov'];
          const secondSemesterMonths = ['Dec', 'Jan', 'Feb', 'Mar', 'Apr', 'May'];

          // Process each month
          [...firstSemesterMonths, ...secondSemesterMonths].forEach(month => {
            let yearForMonth = firstSemesterMonths.includes(month) ? startYear : endYear;

            // Get the attendance for the month
            const monthData = attendanceData.Presenty?.Presenty?.[yearForMonth]?.[month] || {};

            let presentCount = 0;
            let absentCount = 0;
            let leaveCount = 0;

            // Count attendance status for each day in the month
            Object.keys(monthData).forEach(day => {
              const statusObj = monthData[day];
              let status;

              if (statusObj && typeof statusObj === 'object') {
                status = statusObj.present || statusObj.status;
              } else {
                status = statusObj;
              }

              if (status === 'present' || status === true) {
                presentCount++;
              } else if (status === 'absent' || status === false) {
                absentCount++;
              } else if (status === null || status === undefined) {
                leaveCount++;
              }
            });

            // Store the counts in the fetched attendance data
            fetchedAttendance.Present[month] = presentCount;
            fetchedAttendance.Absent[month] = absentCount;
            fetchedAttendance.Leave[month] = leaveCount;
          });

          console.log('PROCESSED ATTENDANCE:', fetchedAttendance);
          resolve(fetchedAttendance);
        };

        request.onerror = (event) => {
          console.error("Error fetching attendance from IndexedDB:", event.target.error);
          reject(event.target.error);
        };
      });
    } catch (error) {
      console.error('Error in fetchAttendanceFromIndexedDB:', error);
      return null;
    }
  };




  useEffect(() => {
    const fetchAttendanceData = async () => {
      console.log('FETCH ATTENDANCE EFFECT TRIGGERED');
      console.log('Selected Student:', selectedStudentForSr);
      console.log('Academic Year:', academicYear);

      if (!selectedStudentForSr) {
        console.warn('No student selected');
        return;
      }

      const srNo = selectedStudentForSr.serialNo;
      console.log('Student SR No:', srNo);
      const academicYearParts = academicYear.split('-');

      try {
        const attendanceData = await fetchAttendanceFromIndexedDB(srNo, academicYearParts[0] + '-' + academicYearParts[1]);

        if (attendanceData) {
          setAttendance(attendanceData);
          console.log('FINAL ATTENDANCE SET:', attendanceData);
        } else {
          console.warn('No attendance data found');
          setAttendance({
            Present: {},
            Absent: {},
            Leave: {}
          });
        }
      } catch (error) {
        console.error('Error fetching attendance data:', error);
        setAttendance({
          Present: {},
          Absent: {},
          Leave: {}
        });
      }
    };

    fetchAttendanceData();
  }, [selectedStudentForSr, academicYear]);


  const [summerVacationDate, setSummerVacationDate] = useState('');
  const [winterVacationDate, setWinterVacationDate] = useState('');

  // Define the English month names
  const firstSemesterMonths = ['June', 'July', 'Aug', 'Sep', 'Oct', 'Nov'];
  const secondSemesterMonths = ['Dec', 'Jan', 'Feb', 'Mar', 'Apr', 'May'];

  // Function to translate month to Marathi if needed
  const getMonthName = (month) => {
    const marathiMonths = {
      June: 'जून', July: 'जुलै', Aug: 'ऑगस्ट', Sep: 'सप्टेंबर', Oct: 'ऑक्टोबर', Nov: 'नोव्हेंबर',
      Dec: 'डिसेंबर', Jan: 'जानेवारी', Feb: 'फेब्रुवारी', Mar: 'मार्च', Apr: 'एप्रिल', May: 'मे'
    };
    return language === "English" ? month : marathiMonths[month];
  };

  const getAttendanceType = (type) => {
    const marathiTypes = {
      Present: 'उपस्थित',
      Absent: 'गैरहजर',
      Leave: 'रजा'
    };
    return language === "English" ? type : marathiTypes[type];
  };



  const handleDivisionChange = (e) => {
    const selectedDivision = e.target.value;
    setDivision(selectedDivision); // Update division state

    let filteredStudents;

    if (selectedDivision === "") {
      // Show all students from the selected class if "All Student" is chosen
      filteredStudents = studentData.filter((student) => student.currentClass === classValue);
    } else {
      // Filter by class and division
      filteredStudents = studentData.filter(
        (student) => student.currentClass === classValue && student.division === selectedDivision
      );
    }

    setSelectedStudents(filteredStudents);
  };




  const getSubjectMarkOrGrade = (subject, testType) => {
    // Convert dot to underscore to match stored keys
    const safeSubjectKey = subject.replace(/\./g, '_');
    const marks = selectedStudentResults.firstSemester?.[testType]?.[safeSubjectKey]?.obtainMarks;
    const grade = selectedStudentResults.firstSemester?.[testType]?.[safeSubjectKey]?.grade;
    return marks !== undefined ? marks : grade || '-';
  };

  // Add this state at the top of your component
  const [oralSkillsGrades, setOralSkillsGrades] = useState({
    english: {
      conversation: '',
      expressesIdeas: '',
      reading: '',
      conversation1: '',
      expressesIdeas1: '',
      reading1: '',
    },
    marathi: {
      conversation: '',
      reading: '',
      recitation: '',
      conversation1: '',
      reading1: '',
      recitation1: ''
    },
    maths: {
      clarityOfConcept: '',
      recognitionCounting: '',
      numberFormation: '',
      clarityOfConcept1: '',
      recognitionCounting1: '',
      numberFormation1: ''
    },
    evs: {
      generalAwareness: '',
      mySelf: '',
      aboutAnimals: '',
      internalBodyParts: '',
      generalAwareness1: '',
      mySelf1: '',
      aboutAnimals1: '',
      internalBodyParts1: ''
    },
    personality: {
      selfControl: '',
      respectsOthers: '',
      neatnessCleanliness: '',
      obeyingTeachers: '',
      selfControl1: '',
      respectsOthers1: '',
      neatnessCleanliness1: '',
      obeyingTeachers1: ''
    },
    extra: {
      conducts: '',
      teacherRemarks: '',
      conducts1: '',
      teacherRemarks1: ''
    }
  });


  // Add this function to handle grade changes
  const handleGradeChange = (subject, skill, value) => {
    setOralSkillsGrades(prev => ({
      ...prev,
      [subject]: {
        ...prev[subject],
        [skill]: value
      }
    }));
  };

  const [conducts, setConducts] = useState();

  const [teacherRemarks, setTeacherRemarks] = useState('');

  const handleConductChange = (key, value) => {
    setConducts(prev => ({ ...prev, [key]: value }));
  };

  const handlePrint = () => {
    const printContent = document.querySelector('.modal-body');

    if (printContent) {
      const printWindow = window.open('', '', 'height=600,width=800');
      printWindow.document.write(`
      <html>
        <head>
          <title>Print Student Report</title>
          <style>
            @page {
              size: A4 Landscape;
              margin: 3mm;
            }
            
            * {
              box-sizing: border-box;
              -webkit-print-color-adjust: exact !important;
              print-color-adjust: exact !important;
            }
            
            body {
              font-family: 'Poppins', sans-serif;
              margin: 0;
              padding: 0;
              color: black;
              font-size: 11px;
            }

            /* First Container Styles */
            .container.mt-1:first-child {
              width: 297mm;
              height: 208mm;
              margin: 0 auto;
              padding: 3mm;
              border: 3px solid #0e0303;
              display: flex;
              justify-content: space-between;
              margin-bottom: 20px;
              background-size: cover;
              background-repeat: no-repeat;
              background-position: center;
            }

            /* Second Container Styles */
            .container.mt-1:last-child {
              width: 297mm;
              height: 208mm;
              margin: 0 auto;
              padding: 3mm;
              border: 3px solid #0e0303;
              display: flex;
              justify-content: space-between;
              margin-bottom: 20px;
              background: #f5faf9;
            }

            .left, .right {
              width: 49%;
              border: 2px solid black;
              padding: 5px;
              position: relative;
            }

            /* First container left/right styles */
            .container.mt-1:first-child .left {
              background: #dff9fc;
            }
            .container.mt-1:first-child .right {
              background: #fef2fb;
            }

            /* Second container left/right styles */
            .container.mt-1:last-child .left {
              background: #dff9fc;
              padding: 5px;
            }
            .container.mt-1:last-child .right {
              background: #fef2fb;
              padding: 5px;
            }

            /* Common styles for both containers */
            .left-box {
              background-color: #f9f9f9;
              padding: 20px;
              border: 1px solid black;
              border-radius: 10px;
            }

            .school-info {
              display: flex;
              align-items: center;
              margin-bottom: 20px;
            }

            .school-info img {
              width: 100px;
              height: 100px;
              object-fit: cover;
              margin-right: 20px;
            }

            .school-info h2 {
              font-size: 18px;
              font-weight: bold;
              margin: 0;
            }

            /* Student Info Grid */
            .student-info-grid {
              display: grid;
              grid-template-columns: 1fr 1fr;
              gap: 10px;
              background-color: #f9f9f9;
              padding: 15px;
              border: 1px solid black;
              border-radius: 10px;
              margin-bottom: 10px;
            }

            .student-info-grid p {
              margin: 5px 0;
              font-size: 12px;
            }

            .student-info-grid label {
              font-weight: bold;
              margin-right: 5px;
            }

            .student-info-grid span {
              color: #333;
            }

            /* Gradable Table */
            .gradable {
              position: absolute;
              bottom: 2px;
              left: 1%;
              width: 98%;
            }

            .gradable table {
              width: 100%;
              border-collapse: collapse;
              margin-top: 10px;
            }

            .gradable th, .gradable td {
              border: 1px solid #000;
              padding: 5px;
              text-align: center;
            }

            .gradable th {
              background-color: #f4f4f4;
              font-weight: normal;
            }

            .gradable td {
              background-color: white;
            }

            /* Attendance Tables */
            .attendance-table {
              width: 100%;
              border-collapse: collapse;
              margin-top: 10px;
              background-color: white;
            }

            .attendance-table th {
              font-weight: normal;
              font-size: 12px;
              border: 1px solid #000;
              padding: 5px;
              text-align: center;
              background-color: #f4f4f4;
            }

            .attendance-table td {
              border: 1px solid #000;
              padding: 5px;
              text-align: center;
            }

            .attendance-table td:first-child {
              font-size: 12px;
              font-weight: normal;
              text-align: left;
            }

            .attendance-table input[type="text"] {
              width: 100%;
              border: none;
              background: transparent;
              text-align: center;
              font-size: 12px;
            }

            /* Grad Section */
            .grad {
              position: absolute;
              bottom: 0;
              left: 20px;
              width: 100%;
              font-size: 11px;
              margin-top: 10px;
            }

            .grad p {
              margin: 5px 0;
            }

            .grad li {
              margin-bottom: 3px;
            }

            /* Signature Styles */
            .signature {
              margin-top: 40px;
              margin-left: 350px;
              font-size: 12px;
            }

            /* Date Picker */
            input[type="date"] {
              border: 1px solid #ccc;
              padding: 3px;
              font-size: 12px;
              width: 150px;
            }

            /* Header Image */
            div[style*="backgroundImage"] {
              background-size: cover !important;
              background-repeat: no-repeat !important;
              background-position: center !important;
              font-size: 14px;
              font-weight: bold;
              border: 1px solid #000000;
              height: 120px;
              margin-bottom: 5px;
            }

            /* Subject Tables */
            table[style*="border-radius: 15px"] {
              width: 100%;
              border-collapse: collapse;
              border: 2px solid #000000;
              border-radius: 15px;
              overflow: hidden;
              margin-bottom: 0;
            }

            table[style*="border-radius: 15px"] th {
              border: 1px solid #000000;
              padding: 5px;
              text-align: center;
              background-color: inherit;
            }

            table[style*="border-radius: 15px"] td {
              border: 1px solid #000000;
              padding: 5px;
              text-align: center;
            }

            /* Descriptive Record */
            .descriptive-record {
              vertical-align: top;
              font-size: 12px;
              padding: 6px;
              line-height: 1.3;
            }

            .descriptive-record strong {
              display: block;
              margin: 5px 0;
            }

            .oral-skills-item {
              display: flex;
              justify-content: space-between;
              align-items: center;
              margin-bottom: 4px;
            }

            .oral-skills-input {
              width: 50px;
              margin-left: 10px;
              text-align: center;
              border: 1px solid #ccc;
              padding: 2px;
            }

            /* Personality Development */
            .personality-development {
              font-size: 12px;
            }

            .personality-development h6 {
              margin: 0 0 4px 0;
              font-weight: bold;
            }

            /* Conducts and Remarks */
            .conducts-remarks {
              border: 2px solid #000000;
              border-radius: 0 0 15px 15px;
              padding: 5px;
              background-color: #f8f9fa;
              border-top: none;
            }

            /* Signature Boxes */
            .d-flex.justify-content-between {
              display: flex;
              justify-content: space-between;
              margin-top: 10px;
            }

            .d-flex.align-items-end {
              display: flex;
              align-items: flex-end;
            }

            .text-center {
              text-align: center;
            }

            .border-top {
              border-top: 1px solid #000;
            }

            .pt-1 {
              padding-top: 4px;
            }

            .mb-0 {
              margin-bottom: 0;
            }
              .personality-development {
  font-size: 10px;
}

.personality-development h6 {
  margin: 0 0 4px 0;
  font-size: 10.5px;
  font-weight: bold;
}

.personality-development ul {
  list-style-type: none;
  padding-left: 0;
  margin: 0;
}

.personality-development .oral-skills-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2px;
  font-size: 10px;
}

.personality-development .oral-skills-input {
  width: 40px;
  margin-left: 10px;
  text-align: center;
  font-size: 10px;
  height: 16px;
  border: 1px solid #ccc;
}
     /* Special styles for oral skills evaluation items */
            .oral-skills-section {
              font-size: 8px !important;
              line-height: 1.1 !important;
            }

            .oral-skills-section strong {
              font-size: 8.5px !important;
              margin: 1px 0 !important;
            }

            .oral-skills-list {
              list-style-type: none !important;
              padding-left: 0 !important;
              margin: 1px 0 !important;
            }

            .oral-skills-item {
              display: flex !important;
              justify-content: space-between !important;
              align-items: center !important;
              margin-bottom: 0.5px !important;
              padding: 0.5px 0 !important;
              font-size: 10px !important;
            }

            .oral-skills-label {
              flex: 1 !important;
              white-space: nowrap !important;
            }

            .oral-skills-input {
              width: 30px !important;
              height: 15px !important;
              margin-left: 3px !important;
              padding: 0 !important;
              font-size: 10px !important;
              text-align: center !important;
              border: 1px solid #ccc !important;
            }

            /* Multi-line items */
            .multi-line-item {
              white-space: normal !important;
              line-height: 1 !important;
            }
                    .grad {
  position: absolute;
  bottom: 0;
  left: 20px;
  width: 100%;

}

.d-flex {
  display: flex;
}

.justify-content-between {
  justify-content: space-between; 

}
  .justify-content-center p{
  margin:auto
  }

.align-items-end {
  align-items: flex-end;
}

.text-center {
  text-align: center;
}

    table {
              width: 100%;
              margin-bottom: 0;
              font-size: 10px;
            }


            /* Ensure borders and backgrounds print correctly */
            table, th, td {
              border-color: #000000 !important;
            }
            .left, .right, thead th {
              -webkit-print-color-adjust: exact;
              print-color-adjust: exact;
            }
              .container.mt-1:first-child .left{
              background: transparent;
              }
                 .container.mt-1:first-child .right{
              background: transparent;
              }
          </style>
        </head>
        <body>
          ${printContent.innerHTML}
        </body>
      </html>
    `);
      printWindow.document.close();

      setTimeout(() => {
        printWindow.focus();
        printWindow.print();
      }, 500);
    } else {
      console.error('Print content not found');
    }
  };


  const savedDate = localStorage.getItem('selectedDate');
  // OR for the complete report data:
  const savedReportData = JSON.parse(localStorage.getItem('reportData'));



  const [selectedDate, setSelectedDate] = useState(() => {
    return localStorage.getItem('selectedDate') || '';
  });

  // Load saved date when component mounts
  useEffect(() => {
    const savedDate = localStorage.getItem('selectedDate');
    if (savedDate) {
      setSelectedDate(savedDate);
    }
  }, []);

  const handleDateChange = (e) => {
    const dateValue = e.target.value;
    setSelectedDate(dateValue);
    localStorage.setItem('selectedDate', dateValue);
  };






  return (
    <div>
      {/* <Sidebar /> */}
      <AlertMessage message={alertMessage} show={showAlert} />

      <div className=' main-content-of-page'>
        <h3 style={{ color: 'rgb(3, 54, 94)' }} className="title"> {language === "English" ? " CBSE Progress Sheet" : "प्रगति पत्र"}</h3>

        <table className="table table-striped table-bordered" >
          <tbody>
            <tr>
              <th> {language === "English" ? "Academic Year " : "शैक्षणिक वर्ष"}</th>
              <td>
                <select id="academicYear" value={academicYear} onChange={handleAcademicYearChange} className="form-control custom-select"
                >
                  <option value="">{language === "English" ? "Select Year " : "वर्ष निवडा"}</option>
                  <option value="2023-2024">2023-2024</option>
                  <option value="2024-2025">2024-2025</option>
                  <option value="2025-2026">2025-2026</option>
                  <option value="2026-2027">2026-2027</option>
                </select>
              </td>
            </tr>
            <tr>
              <th> {language === "English" ? "Class " : "वर्ग"} </th>
              <td>
                <select id="class" value={classValue} onChange={handleClassChange} className="form-control custom-select" defaultValue={examNames[0]}
                >
                  <option value="">{language === "English" ? " Select Class " : "वर्ग निवडा"}</option>
                  {classes.map((cls, index) => (
                    <option key={index} value={cls}>
                      {cls}
                    </option>
                  ))}
                </select>
              </td>
            </tr>
            <tr>
              <th>{language === "English" ? "Division" : "तुकडी"}</th>
              <td>
                <select
                  value={division}
                  onChange={handleDivisionChange}
                  className="form-control custom-select"
                >
                  <option value="">
                    {language === "English" ? "All Student" : "सर्व विद्यार्थी"}
                  </option>
                  {divisions
                    .filter((div) => div !== null && div !== undefined && div.trim() !== "")
                    .map((div) => (
                      <option key={div} value={div}>
                        {div}
                      </option>
                    ))}
                </select>
              </td>
            </tr>
            <tr>
              <th>{language === "English" ? "Exam Name " : "परीक्षेचे नाव"}</th>
              <td>
                <select id="examName" value={selectedExamName} onChange={handleExamNameChange} className="form-control custom-select" defaultValue={examNames[0]}
                >
                  <option value="">{language === "English" ? "Select Exam " : "परीक्षा निवडा"}</option>
                  {examNames.map((examName, index) => (
                    <option key={index} value={examName}>
                      {language === "English" ? examName : examNameTranslations[examName]}
                    </option>
                  ))}
                </select>
              </td>
            </tr>



            {selectedExamName === "Semester Second" && (
              <tr>
                <th>{language === "English" ? "Vacation Till" : "तारीख निवडा"}</th>
                <td>
                  <input
                    type="date"
                    value={selectedDate}
                    onChange={(e) => {
                      setSelectedDate(e.target.value);
                      localStorage.setItem('selectedDate', e.target.value);
                    }}
                    className="form-control"
                  />
                </td>
              </tr>
            )}

            {academicYear && academicYear !== "2025-2026" && (
              <tr>
                <th>{language === "English" ? "Previous Year Class" : "मागील वर्षाचा वर्ग"}</th>
                <td>
                  <select
                    value={previousYearClass}
                    onChange={(e) => setPreviousYearClass(e.target.value)}
                    className="form-control custom-select"
                  >
                    <option value="">{language === "English" ? "Select Previous Year Class" : "मागील वर्षाचा वर्ग निवडा"}</option>
                    {classes.map((cls, index) => (
                      <option key={index} value={cls}>
                        {cls}
                      </option>
                    ))}
                  </select>
                </td>
              </tr>
            )}


          </tbody>

        </table>

        {selectedStudents.length > 0 && (
          <div className="mt-4">
            <table className="table table-striped table-bordered custom-table">
              <thead>
                <tr>
                  <th className="custom-width">{language === "English" ? "Roll No" : "हजेरी क्र."}</th>
                  <th>{language === "English" ? "Student Name " : "विद्यार्थ्याचे नाव: "}</th>
                  <th>{language === "English" ? "Result " : "प्रगतीपत्रक"}</th>
                </tr>
              </thead>
              <tbody>
                {[...selectedStudents]
                  .sort((a, b) => a.rollNo - b.rollNo)
                  .map((student) => (
                    <tr key={student.srNo}>
                      <td>{student.rollNo}</td>
                      <td>{student.stdName} {student.stdFather} {student.stdSurname}</td>
                      <td>
                        <button className="btn btn-primary" onClick={() => viewResult(student.srNo)}>
                          {language === "English" ? "View Result" : "प्रगति पत्रक"}
                        </button>

                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        )}
        <Modal show={showModal} onHide={handleCloseModal} dialogClassName='modal-80w'>
          <Modal.Header closeButton>
            <Modal.Title>{language === "English" ? "Student Results " : "विद्यार्थ्यांचे निकाल"}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {selectedExamName === 'Semester Second' && selectedStudentResults ? (
              <div>

                <div className="container mt-1"
                  style={{
                    backgroundImage: `url(${resultBackground}`,
                    backgroundSize: '80%', // Zooms in
                    backgroundSize: 'cover', // or 'contain', depending on your preference
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center',
                  }}
                >

                  <div className="right" >
                    {/* First Semester Attendance Table */}
                    <h2>{language === "English" ? "Attendance:" : "हजेरी"}</h2>
                    <table className="attendance-table" style={{ backgroundColor: 'white' }}>
                      <thead >
                        <tr>
                          <th >{language === "English" ? "Type:" : "प्रकार"}</th>
                          {firstSemesterMonths.map((month, index) => (
                            <th key={index}>{getMonthName(month)}</th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {['Present', 'Absent', 'Leave'].map((type) => (
                          <tr key={type}>
                            <td>{getAttendanceType(type)}</td>
                            {firstSemesterMonths.map((month, index) => (
                              <td key={index}>
                                <input
                                  type="text"
                                  value={type === 'Leave' && attendance[type][month] < 0 ? '' : attendance[type][month] || ''}

                                />
                              </td>
                            ))}
                          </tr>
                        ))}
                      </tbody>
                    </table>

                    {/* Second Semester Attendance Table */}
                    <h5 style={{ marginTop: '10px' }}>{language === "English" ? "Second Semester Attendance:" : "द्वितीय सत्राची हजेरी:"}</h5>
                    <table className="attendance-table" style={{ backgroundColor: 'white' }}>
                      <thead>
                        <tr>
                          <th>{language === "English" ? "Type:" : "प्रकार"}</th>
                          {secondSemesterMonths.map((month, index) => (
                            <th key={index}>{getMonthName(month)}</th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {['Present', 'Absent', 'Leave'].map((type) => (
                          <tr key={type}>
                            <td>{getAttendanceType(type)}</td>
                            {secondSemesterMonths.map((month, index) => (
                              <td key={index}>
                                <input
                                  type="text"
                                  value={type === 'Leave' && attendance[type][month] < 0 ? '' : attendance[type][month] || ''}
                                // onChange={(e) => handleInputChange(type, month, e.target.value)}
                                />
                              </td>
                            ))}
                          </tr>
                        ))}
                      </tbody>
                    </table>


                    <p style={{ marginTop: '5px' }}>{language === "English" ? "After the summer vacation school will start from." : "उन्हाळी सुटीनंतर शाळा दि. पासून सुरू होईल."}</p>
                    <div style={{ width: '150px' }}>
                      <input
                        type="date"
                        value={selectedDate}
                        onChange={handleDateChange}
                        className="form-control"
                      />
                    </div>

                    <div className="grad">
                      <p>
                        {language === "English" ? " Instructions for parents:" : "पालकांसाठी सूचना"}
                        <li>  {language === "English" ? " Students should wear school uniform every day." : "विद्यार्थ्यांनी दररोज शालेय गणवेश परिधान करावा."}</li>
                        <li> {language === "English" ? "  A student should do the study given in school every day." : "विद्यार्थ्याने शाळेत दिलेला अभ्यास दररोज करावा."}</li>
                        <li> {language === "English" ? " Students should attend school on time and regularly every day." : "विद्यार्थ्यांनी दररोज वेळेवर व नियमितपणे शाळेत हजर राहावे."}</li>
                        <li> {language === "English" ? " Students should not carry valuables, money. " : "विद्यार्थ्यांनी मौल्यवान वस्तू, पैसे घेऊन जाऊ नये."}</li>
                        <li>  {language === "English" ? " Students should follow the rules and discipline of the school. " : "विद्यार्थ्यांनी शाळेचे नियम व शिस्तीचे पालन करावे."}</li>
                      </p>
                    </div>


                    <p style={{ marginTop: '40px', marginLeft: '350px' }}>{language === "English" ? "Teacher Signature " : "पालकांची सही"}</p>
                  </div>
                  <div className="left"  >
                    <div className="left-box" style={{ border: '1px solid black', paddingBottom: '0px' }}>
                      <div style={{ marginBottom: '10px', position: 'relative', minHeight: '150px' }}>
                        {/* Logo and Name Row */}
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '15px',
                            marginBottom: '10px',
                          }}
                        >
                          {schoolLogo && (
                            <div>
                              <img
                                src={schoolLogo}
                                alt="Logo"
                                style={{
                                  width: '100px',
                                  height: '100px',
                                  objectFit: 'cover',
                                }}
                              />
                            </div>
                          )}

                          {/* Name Container */}
                          <div>
                            <h3
                              style={{
                                fontSize: '12px',
                                margin: 0,
                                fontWeight: 'normal',
                              }}
                            >
                              {sansthaName}
                            </h3>
                            <h2
                              style={{
                                fontSize: '18px',
                                fontWeight: 'bold',
                                margin: 0,
                              }}
                            >
                              {schoolName}
                            </h2>
                          </div>
                        </div>

                        {/* Address Information Row - Centered at Bottom of Container */}
                        <div
                          style={{
                            position: 'absolute',
                            bottom: '0',
                            left: '50%',
                            transform: 'translateX(-50%)',
                            fontSize: '12px',
                            color: 'black',
                            whiteSpace: 'nowrap',
                            textAlign: 'center',
                            width: '100%',
                            paddingBottom: '0',
                          }}
                        >
                          <span>
                            {taluka && jilha && (
                              <>
                                {language === 'English' ? 'Tal: ' : 'तालुका :'} {taluka},{' '}
                                {language === 'English' ? 'Dist: ' : 'जिल्हा :'} {jilha},{' '}
                              </>
                            )}
                            {mobileNumber && (
                              <>
                                {language === 'English' ? 'Mob No: ' : 'फोन नं. :'} {mobileNumber},{' '}
                              </>
                            )}
                            {udiseNumber && (
                              <>
                                {language === 'English' ? 'UDISE: ' : 'UDISE:'} {udiseNumber}{' '}
                              </>
                            )}
                          </span>
                        </div>
                      </div>
                    </div>
                    <br />

                    <div
                      className="student-info-grid"
                      style={{
                        border: '1px solid black',
                        padding: '4px',
                        fontSize: '14px',
                        lineHeight: '1.2',
                        marginBottom: '10px',
                        padding: '15px',
                      }}
                    >
                      {/* Name in single line */}
                      <p style={{ gridColumn: '1 / span 2', margin: '1px 0' }}>
                        <label style={{ marginRight: '4px', fontSize: '14px' }}>{language === "English" ? "Name :" : "नाव :"}</label>
                        <span>
                          {`${selectedStudentResults?.studentInfo?.name || ''} ${selectedStudentResults?.studentInfo?.father || ''} ${selectedStudentResults?.studentInfo?.surname || ''}`}
                        </span>
                      </p>

                      {/* Roll No on its own line */}
                      <p style={{ margin: '1px 0' }}>
                        <label style={{ marginRight: '4px', fontSize: '14px' }}>{language === "English" ? "Roll No :" : "हजेरी क्र. :"}</label>
                        <span>{selectedStudentResults?.studentInfo?.rollNo || ' '}</span>
                      </p>

                      {/* Rest of the fields in 2-column layout */}
                      <p style={{ margin: '1px 0' }}>
                        <label style={{ marginRight: '4px', fontSize: '14px' }}>{language === "English" ? "Exam :" : "परीक्षा सत्र :"}</label>
                        <span>{selectedExamName || ' '}</span>
                      </p>
                      <p style={{ margin: '1px 0' }}>
                        <label style={{ marginRight: '4px', fontSize: '14px' }}>{language === "English" ? "Year :" : "वर्ष :"}</label>
                        <span>{academicYear || ' '}</span>
                      </p>
                      <p style={{ margin: '1px 0' }}>
                        <label style={{ marginRight: '4px', fontSize: '14px' }}>{language === "English" ? "Class :" : "वर्ग :"}</label>
                        <span>{selectedStudentResults?.studentInfo?.class || ' '}</span>
                      </p>
                      <p style={{ margin: '1px 0' }}>
                        <label style={{ marginRight: '4px', fontSize: '14px' }}>{language === "English" ? "Mother's Name :" : "आईचे नाव :"}</label>
                        <span>{selectedStudentResults?.studentInfo?.stdMother || ''}</span>
                      </p>
                      <p style={{ margin: '1px 0' }}>
                        <label style={{ marginRight: '4px', fontSize: '14px' }}>{language === "English" ? "DOB :" : "जन्मतारीख :"}</label>
                        <span>{selectedStudentResults?.studentInfo?.dob || ' '}</span>
                      </p>
                      <p style={{ margin: '1px 0' }}>
                        <label style={{ marginRight: '4px', fontSize: '14px' }}>{language === "English" ? "Division :" : "तुकडी :"}</label>
                        <span>{selectedStudentResults?.studentInfo?.division || ' '}</span>
                      </p>
                      <p style={{ margin: '1px 0' }}>
                        <label style={{ marginRight: '4px', fontSize: '14px' }}>{language === "English" ? "Mother Tongue :" : "मातृभाषा :"}</label>
                        <span>{selectedStudentResults?.studentInfo?.motherTounge || ' '}</span>
                      </p>
                      <p style={{ margin: '1px 0' }}>
                        <label style={{ marginRight: '4px', fontSize: '14px' }}>{language === "English" ? "Student ID :" : "विद्यार्थी आयडी :"}</label>
                        <span>{selectedStudentResults?.studentInfo?.studentId || ' '}</span>
                      </p>
                      <p style={{ margin: '1px 0' }}>
                        <label style={{ marginRight: '4px', fontSize: '14px' }}>{language === "English" ? "Gender :" : "लिंग :"}</label>
                        <span>{selectedStudentResults?.studentInfo?.gender || ' '}</span>
                      </p>
                    </div>
                    <div className="gradable">
                      <table>
                        <thead>
                          <tr>
                            <th rowSpan="2"></th>
                            <th colSpan="1">{language === "English" ? "First Semester" : "प्रथम सत्र"}</th>
                            <th colSpan="1">{language === "English" ? "Second Semester" : "द्वितीय सत्र"}</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr style={{ backgroundColor: 'white' }}>
                            <td>{language === "English" ? "Weight" : "वजन"} (Kg)</td>
                            <td>{selectedStudentResults?.studentInfo?.weightSeptember || '-'}</td>
                            <td>{selectedStudentResults?.studentInfo?.weightMarch || '-'}</td>
                          </tr>
                          <tr style={{ backgroundColor: 'white' }}>
                            <td>{language === "English" ? "Height" : "उंची"} (Cm)</td>
                            <td>{selectedStudentResults?.studentInfo?.heightSeptember || '-'}</td>
                            <td>{selectedStudentResults?.studentInfo?.heightMarch || '-'}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>

                </div>

                <div className="container mt-1" style={{ background: '#f5faf9' }}>


                  <div className="left" style={{ padding: '5px', background: '#dff9fc' }}>
                    <div style={{
                      backgroundImage: `url(${resultTermFirst})`,
                      backgroundSize: 'cover',        // or 'contain'
                      backgroundRepeat: 'no-repeat',
                      backgroundPosition: 'center',
                      fontSize: '14px',
                      fontWeight: 'bold',
                      border: '1px solid #000000',
                      height: '120px',
                      marginBottom: '5px'
                    }}
                    >
                    </div>
                    {selectedStudentResults && (
                      <div style={{ fontSize: "13px" }}>
                        <div>
                          <table style={{ borderRadius: '15px', overflow: 'hidden', border: '2px solid #000000', borderCollapse: 'separate', borderBottomLeftRadius: '0', borderBottomRightRadius: '0', borderBottom: 'none' }}>
                            <thead>
                              <tr>
                                <th style={{ width: '30px', border: '1px solid #000000', backgroundColor: '#dff9fc' }} rowSpan="2">{language === "English" ? "Sr." : "क्र."}</th>
                                <th style={{ width: '520px', border: '1px solid #000000', background: '#dff9fc' }} rowSpan="2">{language === "English" ? "Subject" : "विषय"}</th>
                                <th style={{ width: '80px', border: '1px solid #000000', background: '#dff9fc' }}>{language === "English" ? "UT.1" : "युनिट-1"}</th>
                                <th style={{ width: '80px', border: '1px solid #000000', background: '#dff9fc' }}>{language === "English" ? "UT.2" : "युनिट-2"}</th>
                                <th style={{ width: '80px', border: '1px solid #000000', background: '#dff9fc' }}>{language === "English" ? "UT.3" : "युनिट-3"}</th>
                                <th style={{ width: '80px', border: '1px solid #000000', backgroundColor: '#dff9fc' }}>{language === "English" ? "MOY" : "MOY"}</th>
                                <th style={{
                                  width: '180px',
                                  minWidth: '180px',
                                  wordBreak: 'break-word'
                                  , border: '1px solid #000000'
                                  , backgroundColor: '#dff9fc'
                                }} rowSpan="2">
                                  {language === "English" ? "Descriptive Record" : "वर्णनात्मक नोंद"}
                                </th>


                              </tr>
                            </thead>
                            <tbody>
                              {subjectSequence
                                .filter(subject => typeof subject === 'string' && subject.trim() !== '')
                                .map((subject, index) => (
                                  <tr key={index} style={{
                                    height: '24px',  // Reduced row height
                                    lineHeight: '24px'  // Matches height for vertical centering
                                    , border: '1px solid #000000'
                                  }}>
                                    <td style={{
                                      padding: '0 4px',  // Top/bottom: 0, Left/right: 4px
                                      textAlign: 'center'
                                      , border: '1px solid #000000'
                                    }}>{index + 1}</td>
                                    <td style={{
                                      padding: '0 4px'  // Top/bottom: 0, Left/right: 4px
                                      , border: '1px solid #000000',
                                      textAlign: 'left',
                                    }}>{subject}</td>
                                    <td style={{
                                      padding: '0 4px',  // Top/bottom: 0, Left/right: 4px
                                      textAlign: 'center'
                                      , border: '1px solid #000000'
                                    }}>{getSubjectMarkOrGrade(subject, 'unitTestI')}</td>
                                    <td style={{
                                      padding: '0 4px',  // Top/bottom: 0, Left/right: 4px
                                      textAlign: 'center'
                                      , border: '1px solid #000000'
                                    }}>{getSubjectMarkOrGrade(subject, 'unitTestII')}</td>
                                    <td style={{
                                      padding: '0 4px',  // Top/bottom: 0, Left/right: 4px
                                      textAlign: 'center'
                                      , border: '1px solid #000000'
                                    }}>{getSubjectMarkOrGrade(subject, 'unitTestIII')}</td>
                                    <td style={{
                                      padding: '0 4px',  // Top/bottom: 0, Left/right: 4px
                                      textAlign: 'center'
                                      , border: '1px solid #000000'
                                    }}>{getSubjectMarkOrGrade(subject, 'semester')}</td>
                                    {index === 0 && (
                                      <td
                                        rowSpan={subjectSequence.filter(subject => typeof subject === 'string' && subject.trim() !== '').length + 1}
                                        style={{
                                          verticalAlign: "top",
                                          fontSize: "12px",
                                          padding: "6px",
                                          lineHeight: '1.3',
                                          border: '1px solid #000000',
                                          height: 'auto' // Let it expand naturally
                                        }}
                                      >
                                        {/* <td rowSpan="11" style={{ verticalAlign: "top", fontSize: "12px", padding: "2px" }}> */}


                                        <strong >{language === "English" ? "English Oral Skills:" : "मौखिक कौशल्ये:"}</strong>
                                        <ul style={{
                                          listStyleType: 'none',
                                          paddingLeft: 0,
                                          marginBottom: 0,
                                          width: '100%'  // Ensure full width
                                        }}>
                                          <li className="oral-skills-item" style={{
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'center',
                                            marginBottom: '4px'
                                          }}>
                                            <span>- Conversation:</span>
                                            <input
                                              className="oral-skills-input"
                                              type="text"
                                              value={oralSkillsGrades.english.conversation1}
                                              onChange={(e) => handleGradeChange('english', 'conversation1', e.target.value)}
                                              style={{
                                                width: '50px',
                                                marginLeft: '10px',
                                                textAlign: 'center'
                                              }}
                                            />
                                          </li>
                                          <li className="oral-skills-item" style={{
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'center',
                                            marginBottom: '4px'
                                          }}>
                                            <span>- Expresses ideas:</span>
                                            <input
                                              className="oral-skills-input"
                                              type="text"
                                              value={oralSkillsGrades.english.expressesIdeas1}
                                              onChange={(e) => handleGradeChange('english', 'expressesIdeas1', e.target.value)}
                                              style={{
                                                width: '50px',
                                                marginLeft: '10px',
                                                textAlign: 'center'
                                              }}
                                            />
                                          </li>
                                          <li className="oral-skills-item" style={{
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'center'
                                          }}>
                                            <span>- Reading:</span>
                                            <input
                                              className="oral-skills-input"
                                              type="text"
                                              value={oralSkillsGrades.english.reading1}
                                              onChange={(e) => handleGradeChange('english', 'reading1', e.target.value)}
                                              style={{
                                                width: '50px',
                                                marginLeft: '10px',
                                                textAlign: 'center'
                                              }}
                                            />
                                          </li>
                                        </ul>

                                        <strong>{language === "English" ? "Marathi Oral Skills:" : "मौखिक कौशल्ये:"}</strong>
                                        <ul style={{
                                          listStyleType: 'none',
                                          paddingLeft: 0,
                                          marginBottom: 0,
                                          width: '100%'  // Ensure full width
                                        }} >
                                          <li className="oral-skills-item" style={{
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'center',
                                            marginBottom: '4px'
                                          }}>
                                            <span> - Conversation: </span>
                                            <input
                                              className="oral-skills-input"
                                              type="text"
                                              value={oralSkillsGrades.marathi.conversation1}
                                              onChange={(e) => handleGradeChange('marathi', 'conversation1', e.target.value)}
                                              style={{
                                                width: '50px',
                                                marginLeft: '10px',
                                                textAlign: 'center'
                                              }}
                                            />
                                          </li>
                                          <li className="oral-skills-item" style={{
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'center',
                                            marginBottom: '4px'
                                          }}>
                                            <span>- Reading:</span>
                                            <input
                                              className="oral-skills-input"
                                              type="text"
                                              value={oralSkillsGrades.marathi.reading1}
                                              onChange={(e) => handleGradeChange('marathi', 'reading1', e.target.value)}
                                              style={{
                                                width: '50px',
                                                marginLeft: '10px',
                                                textAlign: 'center'
                                              }}
                                            />
                                          </li>
                                          <li className="oral-skills-item" style={{
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'center',
                                            marginBottom: '4px'
                                          }}>
                                            <span>- Recitation:</span>
                                            <input
                                              className="oral-skills-input"
                                              type="text"
                                              value={oralSkillsGrades.marathi.recitation1}
                                              onChange={(e) => handleGradeChange('marathi', 'recitation1', e.target.value)}
                                              style={{
                                                width: '50px',
                                                marginLeft: '10px',
                                                textAlign: 'center'
                                              }}
                                            />
                                          </li>
                                        </ul>

                                        <strong>{language === "English" ? "Maths Oral Skills:" : "मौखिक कौशल्ये:"}</strong>
                                        <ul style={{
                                          listStyleType: 'none',
                                          paddingLeft: 0,
                                          marginBottom: 0,
                                          width: '100%'  // Ensure full width
                                        }}>
                                          <li className="oral-skills-item" style={{
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'center'
                                          }}>
                                            <span>- Clarity Of Concept: </span>
                                            <input
                                              className="oral-skills-input"
                                              type="text"
                                              value={oralSkillsGrades.maths.clarityOfConcept1}
                                              onChange={(e) => handleGradeChange('maths', 'clarityOfConcept1', e.target.value)}
                                              style={{
                                                width: '50px',
                                                marginLeft: '10px',
                                                textAlign: 'center'
                                              }}
                                            />
                                          </li>
                                          <li className="oral-skills-item"
                                            style={{
                                              display: 'flex',
                                              justifyContent: 'space-between',
                                              alignItems: 'center', // center vertically
                                              padding: '4px 0'
                                            }}
                                          >
                                            <span style={{ flex: 1, textAlign: 'left' }}>
                                              - Recognition & Counting:
                                            </span>
                                            <input
                                              className="oral-skills-input"
                                              type="text"
                                              value={oralSkillsGrades.maths.recognitionCounting1}
                                              onChange={(e) => handleGradeChange('maths', 'recognitionCounting1', e.target.value)}
                                              style={{
                                                width: '50px',
                                                textAlign: 'center'
                                              }}
                                            />
                                          </li>

                                          <li className="oral-skills-item" style={{
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'center'
                                          }}>
                                            <span> - Number Formation: </span>
                                            <input
                                              className="oral-skills-input"
                                              type="text"
                                              value={oralSkillsGrades.maths.numberFormation1}
                                              onChange={(e) => handleGradeChange('maths', 'numberFormation1', e.target.value)}
                                              style={{
                                                width: '50px',
                                                marginLeft: '10px',
                                                textAlign: 'center'
                                              }}
                                            />
                                          </li>
                                        </ul>

                                        <strong>{language === "English" ? "EVS Oral Skills:" : "मौखिक कौशल्ये:"}</strong>
                                        <ul style={{
                                          listStyleType: 'none',
                                          paddingLeft: 0,
                                          marginBottom: 0,
                                          width: '100%'  // Ensure full width
                                        }}>
                                          <li className="oral-skills-item" style={{
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'center',
                                            marginBottom: '4px'
                                          }}>
                                            <span>  - General Awareness: </span>
                                            <input
                                              className="oral-skills-input"
                                              type="text"
                                              value={oralSkillsGrades.evs.generalAwareness1}
                                              onChange={(e) => handleGradeChange('evs', 'generalAwareness1', e.target.value)}
                                              style={{
                                                width: '50px',
                                                marginLeft: '10px',
                                                textAlign: 'center'
                                              }} />
                                          </li>
                                          <li className="oral-skills-item" style={{
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'center',
                                            marginBottom: '4px'
                                          }}>
                                            - My Self:
                                            <input
                                              className="oral-skills-input"
                                              type="text"
                                              value={oralSkillsGrades.evs.mySelf1}
                                              onChange={(e) => handleGradeChange('evs', 'mySelf1', e.target.value)}
                                              style={{
                                                width: '50px',
                                                marginLeft: '10px',
                                                textAlign: 'center'
                                              }} />
                                          </li>
                                          <li className="oral-skills-item" style={{
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'center',
                                            marginBottom: '4px'
                                          }}>
                                            - About Animals:
                                            <input
                                              className="oral-skills-input"
                                              type="text"
                                              value={oralSkillsGrades.evs.aboutAnimals1}
                                              onChange={(e) => handleGradeChange('evs', 'aboutAnimals1', e.target.value)}
                                              style={{
                                                width: '50px',
                                                marginLeft: '10px',
                                                textAlign: 'center'
                                              }} />
                                          </li>
                                          <li className="oral-skills-item" style={{
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'center',
                                            marginBottom: '4px'
                                          }}>
                                            - Internal Body Parts:
                                            <input
                                              className="oral-skills-input"
                                              type="text"
                                              value={oralSkillsGrades.evs.internalBodyParts1}
                                              onChange={(e) => handleGradeChange('evs', 'internalBodyParts1', e.target.value)}
                                              style={{
                                                width: '50px',
                                                marginLeft: '10px',
                                                textAlign: 'center'
                                              }} />
                                          </li>
                                        </ul>
                                      </td>
                                    )}
                                  </tr>
                                ))}
                              {/* Personality Development Row */}
                              <tr className="personality-development">
                                <td colSpan="6" className="p-2" style={{ border: '1px solid #000000' }}>
                                  <h6 className="mb-1">
                                    <strong>{language === "English" ? "PERSONALITY DEVELOPMENT" : "व्यक्तिमत्व विकास"}</strong>
                                  </h6>
                                  <ul className="list-unstyled mb-0" style={{ fontSize: "12px" }}>
                                    <li className="oral-skills-item" style={{
                                      display: 'flex',
                                      justifyContent: 'space-between',
                                      alignItems: 'center',
                                      marginBottom: '4px',
                                    }}>
                                      - {language === "English" ? "Exhibits self control" : "स्वतःवर नियंत्रण ठेवते"}:
                                      <input
                                        className="oral-skills-input"
                                        type="text"
                                        value={oralSkillsGrades.personality.selfControl1}
                                        onChange={(e) => handleGradeChange('personality', 'selfControl1', e.target.value)}
                                        style={{
                                          width: '50px',
                                          marginLeft: '10px',
                                          textAlign: 'center'
                                        }} />
                                    </li>
                                    <li className="oral-skills-item" style={{
                                      display: 'flex',
                                      justifyContent: 'space-between',
                                      alignItems: 'center',
                                      marginBottom: '4px'
                                    }}>
                                      - {language === "English" ? "Respects Others" : "इतरांचा आदर करते"}:
                                      <input
                                        className="oral-skills-input"
                                        type="text"
                                        value={oralSkillsGrades.personality.respectsOthers1}
                                        onChange={(e) => handleGradeChange('personality', 'respectsOthers1', e.target.value)}
                                        style={{
                                          width: '50px',
                                          marginLeft: '10px',
                                          textAlign: 'center'
                                        }} />
                                    </li>
                                    <li className="oral-skills-item" style={{
                                      display: 'flex',
                                      justifyContent: 'space-between',
                                      alignItems: 'center',
                                      marginBottom: '4px'
                                    }}>
                                      - {language === "English" ? "Neatness & Cleanliness" : "स्वच्छता आणि सफाई"}:
                                      <input
                                        className="oral-skills-input"
                                        type="text"
                                        value={oralSkillsGrades.personality.neatnessCleanliness1}
                                        onChange={(e) => handleGradeChange('personality', 'neatnessCleanliness1', e.target.value)}
                                        style={{
                                          width: '50px',
                                          marginLeft: '10px',
                                          textAlign: 'center'
                                        }} />
                                    </li>
                                    <li className="oral-skills-item" style={{
                                      display: 'flex',
                                      justifyContent: 'space-between',
                                      alignItems: 'center',
                                      marginBottom: '4px'
                                    }}>
                                      - {language === "English" ? "Obeying Teachers" : "शिक्षकांचे आज्ञापालन"}:
                                      <input
                                        className="oral-skills-input"
                                        type="text"
                                        value={oralSkillsGrades.personality.obeyingTeachers1}
                                        onChange={(e) => handleGradeChange('personality', 'obeyingTeachers1', e.target.value)}
                                        style={{
                                          width: '50px',
                                          marginLeft: '10px',
                                          textAlign: 'center'
                                        }} />
                                    </li>
                                  </ul>
                                </td>
                              </tr>
                            </tbody>

                          </table>



                          {/* Conducts and Remarks Section */}
                          <div
                            style={{
                              marginTop: '0px',
                              border: '2px solid #000000',
                              borderRadius: '15px',
                              padding: '5px',
                              backgroundColor: '#dff9fc',
                              boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                              borderTopLeftRadius: '0',
                              borderTopRightRadius: '0',
                              borderTop: 'none',


                            }}
                          >
                            {/* Conducts */}
                            <div style={{ marginBottom: '16px' }}>
                              <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '12px'
                              }}>
                                <h6 style={{
                                  margin: 0,
                                  minWidth: '120px',
                                  fontSize: '14px',
                                  fontWeight: '600',
                                  color: '#333',
                                  fontSize: '12px',
                                }}>
                                  {language === "English" ? "Conducts" : "वर्तन"}
                                </h6>
                                <input
                                  value={oralSkillsGrades.extra.conducts1}
                                  onChange={(e) => handleGradeChange('extra', 'conducts1', e.target.value)}
                                  style={{
                                    flex: 1,
                                    maxHeight: '80px',
                                    padding: '4px',
                                    border: '1px solid #ccc',
                                    borderRadius: '4px',
                                    resize: 'vertical',
                                    fontSize: '14px',
                                    fontFamily: 'inherit',
                                    fontSize: '12px',
                                  }}
                                  placeholder={language === "English" ? "Enter conducts..." : "वर्तन टाका..."}
                                />
                              </div>
                            </div>

                            {/* Teacher's Remarks */}
                            <div>
                              <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '12px'
                              }}>
                                <h6 style={{
                                  margin: 0,
                                  minWidth: '120px',
                                  fontSize: '12px',
                                  fontWeight: '600',
                                  color: '#333'
                                }}>
                                  {language === "English" ? "Teacher's Remarks" : "शिक्षकांचे शेरे"}
                                </h6>
                                <input
                                  value={oralSkillsGrades.extra.teacherRemarks1}
                                  onChange={(e) => handleGradeChange('extra', 'teacherRemarks1', e.target.value)}
                                  style={{
                                    flex: 1,
                                    maxHeight: '80px',
                                    padding: '4px',
                                    border: '1px solid #ccc',
                                    borderRadius: '4px',
                                    resize: 'vertical',
                                    fontSize: '14px',
                                    fontFamily: 'inherit',
                                    fontSize: '12px',
                                  }}
                                  placeholder={language === "English" ? "Enter remarks..." : "शेरे टाका..."}
                                />
                              </div>
                            </div>
                          </div>

                        </div>
                      </div>
                    )}


                    <div className="grad d-flex justify-content-between mt-2">
                      <div className="d-flex align-items-end justify-content-center text-center" style={{ width: "23%" }}>
                        <p className="border-top pt-1 mb-0" style={{ fontSize: "11px", color: "#000" }}>
                          {language === "English" ? "Parent's Sign" : "पालकांची स्वाक्षरी"}
                        </p>

                      </div>
                      <div className="d-flex align-items-end justify-content-center text-center" style={{ width: "33%" }}>
                        <p className="border-top pt-1 mb-0" style={{ fontSize: "11px", color: "#000" }}>
                          {language === "English" ? "Class Teacher Sign" : "वर्ग शिक्षक"}
                        </p>
                      </div>
                      <div className="d-flex align-items-end justify-content-center text-center" style={{ width: "33%" }}>
                        <p className="border-top pt-1 mb-0" style={{ fontSize: "11px", color: "#000" }}>
                          {language === "English" ? "Principal Sign" : "मुख्याध्यापक"}
                        </p>
                      </div>
                    </div>


                  </div>




                  <div className="right" style={{ padding: '5px', background: '#fef2fb' }}>
                    <div style={{
                      backgroundImage: `url(${resultTermFirst1})`,
                      backgroundSize: 'cover',        // or 'contain'
                      backgroundRepeat: 'no-repeat',
                      backgroundPosition: 'center',
                      fontSize: '14px',
                      fontWeight: 'bold',
                      border: '1px solid #000000',
                      height: '120px',
                      marginBottom: '5px'
                    }}></div>
                    {selectedStudentResults && (
                      <div style={{ fontSize: "13px" }}>
                        <div>
                          <table style={{
                            borderRadius: '15px',
                            overflow: 'hidden',
                            border: '2px solid #000000',
                            borderCollapse: 'separate',
                            borderBottomLeftRadius: '0',
                            borderBottomRightRadius: '0',
                            borderBottom: 'none',
                            width: '100%'
                          }}>
                            <thead>
                              <tr>
                                <th style={{ width: '30px', border: '1px solid #000000', background: '#fef2fb' }} rowSpan="2">{language === "English" ? "Sr." : "क्र."}</th>
                                <th style={{ width: '520px', border: '1px solid #000000', background: '#fef2fb' }} rowSpan="2">{language === "English" ? "Subject" : "विषय"}</th>
                                <th style={{ width: '80px', border: '1px solid #000000', background: '#fef2fb' }}>{language === "English" ? "UT.4" : "युनिट-4"}</th>
                                <th style={{ width: '80px', border: '1px solid #000000', background: '#fef2fb' }}>{language === "English" ? "UT.5" : "युनिट-5"}</th>
                                <th style={{ width: '80px', border: '1px solid #000000', background: '#fef2fb' }}>{language === "English" ? "UT.6" : "युनिट-6"}</th>
                                <th style={{ width: '80px', border: '1px solid #000000', background: '#fef2fb' }}>{language === "English" ? "EOY" : "EOY"}</th>
                                <th style={{
                                  width: '180px',
                                  minWidth: '180px',
                                  wordBreak: 'break-word',
                                  border: '1px solid #000000'
                                  , background: '#fef2fb'
                                }} rowSpan="2">
                                  {language === "English" ? "Descriptive Record" : "वर्णनात्मक नोंद"}
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {subjectSequence
                                .filter(subject => typeof subject === 'string' && subject.trim() !== '')
                                .map((subject, index) => {
                                  const unitTestIV = selectedStudentResults.secondSemester?.unitTestIV?.[subject]?.obtainMarks ||
                                    selectedStudentResults.secondSemester?.unitTestIV?.[subject]?.grade || '-';
                                  const unitTestV = selectedStudentResults.secondSemester?.unitTestV?.[subject]?.obtainMarks ||
                                    selectedStudentResults.secondSemester?.unitTestV?.[subject]?.grade || '-';
                                  const unitTestVI = selectedStudentResults.secondSemester?.unitTestVI?.[subject]?.obtainMarks ||
                                    selectedStudentResults.secondSemester?.unitTestVI?.[subject]?.grade || '-';
                                  const semester = selectedStudentResults.secondSemester?.semester?.[subject]?.obtainMarks ||
                                    selectedStudentResults.secondSemester?.semester?.[subject]?.grade || '-';

                                  return (
                                    <tr key={index} style={{
                                      height: '24px',
                                      lineHeight: '24px'
                                    }}>
                                      <td style={{
                                        padding: '0 4px',
                                        textAlign: 'center'
                                        , border: '1px solid #000000'
                                      }}>{index + 1}</td>
                                      <td style={{
                                        padding: '0 4px'
                                        , border: '1px solid #000000',
                                        textAlign: 'left',
                                      }}>{subject}</td>
                                      <td style={{
                                        padding: '0 4px',
                                        textAlign: 'center'
                                        , border: '1px solid #000000'
                                      }}>{unitTestIV}</td>
                                      <td style={{
                                        padding: '0 4px',
                                        textAlign: 'center'
                                        , border: '1px solid #000000'
                                      }}>{unitTestV}</td>
                                      <td style={{
                                        padding: '0 4px',
                                        textAlign: 'center'
                                        , border: '1px solid #000000'
                                      }}>{unitTestVI}</td>
                                      <td style={{
                                        padding: '0 4px',
                                        textAlign: 'center'
                                        , border: '1px solid #000000'
                                      }}>{semester}</td>
                                      {index === 0 && (
                                        <td
                                          rowSpan={subjectSequence.filter(subject => typeof subject === 'string' && subject.trim() !== '').length + 1}
                                          style={{
                                            verticalAlign: "top",
                                            fontSize: "12px",
                                            padding: "6px",
                                            lineHeight: '1.3',
                                            border: '1px solid #000000',
                                            height: 'auto' // Let it expand naturally
                                          }}
                                        >
                                          <strong>{language === "English" ? "English Oral Skills:" : "मौखिक कौशल्ये:"}</strong>
                                          <ul style={{
                                            listStyleType: 'none',
                                            paddingLeft: 0,
                                            marginBottom: 0,
                                            width: '100%'
                                          }}>
                                            <li className="oral-skills-item" style={{
                                              display: 'flex',
                                              justifyContent: 'space-between',
                                              alignItems: 'center',
                                              marginBottom: '4px'
                                            }}>
                                              <span>- Conversation:</span>
                                              <input
                                                className="oral-skills-input"
                                                type="text"
                                                value={oralSkillsGrades.english.conversation}
                                                onChange={(e) => handleGradeChange('english', 'conversation', e.target.value)}
                                                style={{
                                                  width: '50px',
                                                  marginLeft: '10px',
                                                  textAlign: 'center'
                                                }}
                                              />
                                            </li>
                                            <li className="oral-skills-item" style={{
                                              display: 'flex',
                                              justifyContent: 'space-between',
                                              alignItems: 'center',
                                              marginBottom: '4px'
                                            }}>
                                              <span>- Expresses ideas:</span>
                                              <input
                                                className="oral-skills-input"
                                                type="text"
                                                value={oralSkillsGrades.english.expressesIdeas}
                                                onChange={(e) => handleGradeChange('english', 'expressesIdeas', e.target.value)}
                                                style={{
                                                  width: '50px',
                                                  marginLeft: '10px',
                                                  textAlign: 'center'
                                                }}
                                              />
                                            </li>
                                            <li className="oral-skills-item" style={{
                                              display: 'flex',
                                              justifyContent: 'space-between',
                                              alignItems: 'center'
                                            }}>
                                              <span>- Reading:</span>
                                              <input
                                                className="oral-skills-input"
                                                type="text"
                                                value={oralSkillsGrades.english.reading}
                                                onChange={(e) => handleGradeChange('english', 'reading', e.target.value)}
                                                style={{
                                                  width: '50px',
                                                  marginLeft: '10px',
                                                  textAlign: 'center'
                                                }}
                                              />
                                            </li>
                                          </ul>

                                          <strong>{language === "English" ? "Marathi Oral Skills:" : "मौखिक कौशल्ये:"}</strong>
                                          <ul style={{
                                            listStyleType: 'none',
                                            paddingLeft: 0,
                                            marginBottom: 0,
                                            width: '100%'
                                          }}>
                                            <li className="oral-skills-item" style={{
                                              display: 'flex',
                                              justifyContent: 'space-between',
                                              alignItems: 'center',
                                              marginBottom: '4px'
                                            }}>
                                              <span>- Conversation:</span>
                                              <input
                                                className="oral-skills-input"
                                                type="text"
                                                value={oralSkillsGrades.marathi.conversation}
                                                onChange={(e) => handleGradeChange('marathi', 'conversation', e.target.value)}
                                                style={{
                                                  width: '50px',
                                                  marginLeft: '10px',
                                                  textAlign: 'center'
                                                }}
                                              />
                                            </li>
                                            <li className="oral-skills-item" style={{
                                              display: 'flex',
                                              justifyContent: 'space-between',
                                              alignItems: 'center',
                                              marginBottom: '4px'
                                            }}>
                                              <span>- Reading:</span>
                                              <input
                                                className="oral-skills-input"
                                                type="text"
                                                value={oralSkillsGrades.marathi.reading}
                                                onChange={(e) => handleGradeChange('marathi', 'reading', e.target.value)}
                                                style={{
                                                  width: '50px',
                                                  marginLeft: '10px',
                                                  textAlign: 'center'
                                                }}
                                              />
                                            </li>
                                            <li className="oral-skills-item" style={{
                                              display: 'flex',
                                              justifyContent: 'space-between',
                                              alignItems: 'center',
                                              marginBottom: '4px'
                                            }}>
                                              <span>- Recitation:</span>
                                              <input
                                                className="oral-skills-input"
                                                type="text"
                                                value={oralSkillsGrades.marathi.recitation}
                                                onChange={(e) => handleGradeChange('marathi', 'recitation', e.target.value)}
                                                style={{
                                                  width: '50px',
                                                  marginLeft: '10px',
                                                  textAlign: 'center'
                                                }}
                                              />
                                            </li>
                                          </ul>

                                          <strong>{language === "English" ? "Maths Oral Skills:" : "मौखिक कौशल्ये:"}</strong>
                                          <ul style={{
                                            listStyleType: 'none',
                                            paddingLeft: 0,
                                            marginBottom: 0,
                                            width: '100%'
                                          }}>
                                            <li className="oral-skills-item" style={{
                                              display: 'flex',
                                              justifyContent: 'space-between',
                                              alignItems: 'center'
                                            }}>
                                              <span>- Clarity Of Concept:</span>
                                              <input
                                                className="oral-skills-input"
                                                type="text"
                                                value={oralSkillsGrades.maths.clarityOfConcept}
                                                onChange={(e) => handleGradeChange('maths', 'clarityOfConcept', e.target.value)}
                                                style={{
                                                  width: '50px',
                                                  marginLeft: '10px',
                                                  textAlign: 'center'
                                                }}
                                              />
                                            </li>
                                            <li className="oral-skills-item" style={{
                                              display: 'flex',
                                              justifyContent: 'space-between',
                                              alignItems: 'center'
                                            }}>
                                              <span>- Recognition & Counting:</span>
                                              <input
                                                className="oral-skills-input"
                                                type="text"
                                                value={oralSkillsGrades.maths.recognitionCounting}
                                                onChange={(e) => handleGradeChange('maths', 'recognitionCounting', e.target.value)}
                                                style={{
                                                  width: '50px',
                                                  marginLeft: '10px',
                                                  textAlign: 'center'
                                                }}
                                              />
                                            </li>
                                            <li className="oral-skills-item" style={{
                                              display: 'flex',
                                              justifyContent: 'space-between',
                                              alignItems: 'center'
                                            }}>
                                              <span>- Number Formation:</span>
                                              <input
                                                className="oral-skills-input"
                                                type="text"
                                                value={oralSkillsGrades.maths.numberFormation}
                                                onChange={(e) => handleGradeChange('maths', 'numberFormation', e.target.value)}
                                                style={{
                                                  width: '50px',
                                                  marginLeft: '10px',
                                                  textAlign: 'center'
                                                }}
                                              />
                                            </li>
                                          </ul>

                                          <strong>{language === "English" ? "EVS Oral Skills:" : "मौखिक कौशल्ये:"}</strong>
                                          <ul style={{
                                            listStyleType: 'none',
                                            paddingLeft: 0,
                                            marginBottom: 0,
                                            width: '100%'
                                          }}>
                                            <li className="oral-skills-item" style={{
                                              display: 'flex',
                                              justifyContent: 'space-between',
                                              alignItems: 'center',
                                              marginBottom: '4px'
                                            }}>
                                              <span>- General Awareness:</span>
                                              <input
                                                className="oral-skills-input"
                                                type="text"
                                                value={oralSkillsGrades.evs.generalAwareness}
                                                onChange={(e) => handleGradeChange('evs', 'generalAwareness', e.target.value)}
                                                style={{
                                                  width: '50px',
                                                  marginLeft: '10px',
                                                  textAlign: 'center'
                                                }}
                                              />
                                            </li>
                                            <li className="oral-skills-item" style={{
                                              display: 'flex',
                                              justifyContent: 'space-between',
                                              alignItems: 'center',
                                              marginBottom: '4px'
                                            }}>
                                              <span>- My Self:</span>
                                              <input
                                                className="oral-skills-input"
                                                type="text"
                                                value={oralSkillsGrades.evs.mySelf}
                                                onChange={(e) => handleGradeChange('evs', 'mySelf', e.target.value)}
                                                style={{
                                                  width: '50px',
                                                  marginLeft: '10px',
                                                  textAlign: 'center'
                                                }}
                                              />
                                            </li>
                                            <li className="oral-skills-item" style={{
                                              display: 'flex',
                                              justifyContent: 'space-between',
                                              alignItems: 'center',
                                              marginBottom: '4px'
                                            }}>
                                              <span>- About Animals:</span>
                                              <input
                                                className="oral-skills-input"
                                                type="text"
                                                value={oralSkillsGrades.evs.aboutAnimals}
                                                onChange={(e) => handleGradeChange('evs', 'aboutAnimals', e.target.value)}
                                                style={{
                                                  width: '50px',
                                                  marginLeft: '10px',
                                                  textAlign: 'center'
                                                }}
                                              />
                                            </li>
                                            <li className="oral-skills-item" style={{
                                              display: 'flex',
                                              justifyContent: 'space-between',
                                              alignItems: 'center',
                                              marginBottom: '4px'
                                            }}>
                                              <span>- Internal Body Parts:</span>
                                              <input
                                                className="oral-skills-input"
                                                type="text"
                                                value={oralSkillsGrades.evs.internalBodyParts}
                                                onChange={(e) => handleGradeChange('evs', 'internalBodyParts', e.target.value)}
                                                style={{
                                                  width: '50px',
                                                  marginLeft: '10px',
                                                  textAlign: 'center'
                                                }}
                                              />
                                            </li>
                                          </ul>
                                        </td>
                                      )}
                                    </tr>
                                  );
                                })}
                              {/* Personality Development Row */}
                              <tr className="personality-development">
                                <td colSpan="6" className="p-2" style={{ border: '1px solid #000000' }}>
                                  <h6 className="mb-1">
                                    <strong>{language === "English" ? "PERSONALITY DEVELOPMENT" : "व्यक्तिमत्व विकास"}</strong>
                                  </h6>
                                  <ul className="list-unstyled mb-0" style={{ fontSize: "12px" }}>
                                    <li className="oral-skills-item" style={{
                                      display: 'flex',
                                      justifyContent: 'space-between',
                                      alignItems: 'center',
                                      marginBottom: '4px'
                                    }}>
                                      - {language === "English" ? "Exhibits self control" : "स्वतःवर नियंत्रण ठेवते"}:
                                      <input
                                        className="oral-skills-input"
                                        type="text"
                                        value={oralSkillsGrades.personality.selfControl}
                                        onChange={(e) => handleGradeChange('personality', 'selfControl', e.target.value)}
                                        style={{
                                          width: '50px',
                                          marginLeft: '10px',
                                          textAlign: 'center'
                                        }}
                                      />
                                    </li>
                                    <li className="oral-skills-item" style={{
                                      display: 'flex',
                                      justifyContent: 'space-between',
                                      alignItems: 'center',
                                      marginBottom: '4px'
                                    }}>
                                      - {language === "English" ? "Respects Others" : "इतरांचा आदर करते"}:
                                      <input
                                        className="oral-skills-input"
                                        type="text"
                                        value={oralSkillsGrades.personality.respectsOthers}
                                        onChange={(e) => handleGradeChange('personality', 'respectsOthers', e.target.value)}
                                        style={{
                                          width: '50px',
                                          marginLeft: '10px',
                                          textAlign: 'center'
                                        }}
                                      />
                                    </li>
                                    <li className="oral-skills-item" style={{
                                      display: 'flex',
                                      justifyContent: 'space-between',
                                      alignItems: 'center',
                                      marginBottom: '4px'
                                    }}>
                                      - {language === "English" ? "Neatness & Cleanliness" : "स्वच्छता आणि सफाई"}:
                                      <input
                                        className="oral-skills-input"
                                        type="text"
                                        value={oralSkillsGrades.personality.neatnessCleanliness}
                                        onChange={(e) => handleGradeChange('personality', 'neatnessCleanliness', e.target.value)}
                                        style={{
                                          width: '50px',
                                          marginLeft: '10px',
                                          textAlign: 'center'
                                        }}
                                      />
                                    </li>
                                    <li className="oral-skills-item" style={{
                                      display: 'flex',
                                      justifyContent: 'space-between',
                                      alignItems: 'center',
                                      marginBottom: '4px'
                                    }}>
                                      - {language === "English" ? "Obeying Teachers" : "शिक्षकांचे आज्ञापालन"}:
                                      <input
                                        className="oral-skills-input"
                                        type="text"
                                        value={oralSkillsGrades.personality.obeyingTeachers}
                                        onChange={(e) => handleGradeChange('personality', 'obeyingTeachers', e.target.value)}
                                        style={{
                                          width: '50px',
                                          marginLeft: '10px',
                                          textAlign: 'center'
                                        }}
                                      />
                                    </li>
                                  </ul>
                                </td>
                              </tr>
                            </tbody>
                          </table>

                          {/* Conducts and Remarks Section */}
                          {/* <div style={{
                            marginTop: '0px',
                            border: '2px solid #000000',
                            borderRadius: '0 0 15px 15px',
                            padding: '12px',
                            backgroundColor: '#f8f9fa',
                            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                            borderTop: 'none'
                            , background: '#fef2fb'
                          }}>
                       
                            <div style={{ marginBottom: '16px' }}>
                              <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '12px'
                              }}>
                                <h6 style={{
                                  margin: 0,
                                  minWidth: '120px',
                                  fontSize: '12px',
                                  fontWeight: '600',
                                  color: '#333'
                                }}>
                                  {language === "English" ? "Conducts" : "वर्तन"}
                                </h6>
                                <input
                                  value={oralSkillsGrades.extra.conducts}
                                  onChange={(e) => handleGradeChange('extra', 'conducts', e.target.value)}
                                  style={{
                                    flex: 1,
                                    padding: '6px 8px',
                                    border: '1px solid #ccc',
                                    borderRadius: '4px',
                                    fontSize: '12px',
                                    height: '32px'
                                  }}
                                  placeholder={language === "English" ? "Enter conducts..." : "वर्तन टाका..."}
                                />
                              </div>
                            </div>

                            <div>
                              <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '12px'
                              }}>
                                <h6 style={{
                                  margin: 0,
                                  minWidth: '120px',
                                  fontSize: '12px',
                                  fontWeight: '600',
                                  color: '#333'
                                }}>
                                  {language === "English" ? "Teacher's Remarks" : "शिक्षकांचे शेरे"}
                                </h6>
                                <input
                                  value={oralSkillsGrades.extra.teacherRemarks}
                                  onChange={(e) => handleGradeChange('extra', 'teacherRemarks', e.target.value)}
                                  style={{
                                    flex: 1,
                                    padding: '3px 4px',
                                    border: '1px solid #ccc',
                                    borderRadius: '4px',
                                    fontSize: '12px',
                                    height: '32px'
                                  }}
                                  placeholder={language === "English" ? "Enter remarks..." : "शेरे टाका..."}
                                />
                              </div>
                            </div>
                          </div> */}

                          <div
                            style={{
                              marginTop: '0px',
                              border: '2px solid #000000',
                              borderRadius: '15px',
                              padding: '5px',
                              backgroundColor: '#fef2fb',
                              boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                              borderTopLeftRadius: '0',
                              borderTopRightRadius: '0',
                              borderTop: 'none',

                            }}
                          >
                            {/* Conducts */}
                            <div style={{ marginBottom: '16px' }}>
                              <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '12px'
                              }}>
                                <h6 style={{
                                  margin: 0,
                                  minWidth: '120px',
                                  fontSize: '14px',
                                  fontWeight: '600',
                                  color: '#333',
                                  fontSize: '12px',
                                }}>
                                  {language === "English" ? "Conducts" : "वर्तन"}
                                </h6>
                                <input
                                  value={oralSkillsGrades.extra.conducts}
                                  onChange={(e) => handleGradeChange('extra', 'conducts', e.target.value)}
                                  style={{
                                    flex: 1,
                                    maxHeight: '80px',
                                    padding: '4px',
                                    border: '1px solid #ccc',
                                    borderRadius: '4px',
                                    resize: 'vertical',
                                    fontSize: '14px',
                                    fontFamily: 'inherit',
                                    fontSize: '12px',
                                  }}
                                  placeholder={language === "English" ? "Enter conducts..." : "वर्तन टाका..."}
                                />
                              </div>
                            </div>

                            {/* Teacher's Remarks */}
                            <div>
                              <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '12px'
                              }}>
                                <h6 style={{
                                  margin: 0,
                                  minWidth: '120px',
                                  fontSize: '12px',
                                  fontWeight: '600',
                                  color: '#333'
                                }}>
                                  {language === "English" ? "Teacher's Remarks" : "शिक्षकांचे शेरे"}
                                </h6>
                                <input
                                  value={oralSkillsGrades.extra.teacherRemarks}
                                  onChange={(e) => handleGradeChange('extra', 'teacherRemarks', e.target.value)}
                                  style={{
                                    flex: 1,
                                    maxHeight: '80px',
                                    padding: '4px',
                                    border: '1px solid #ccc',
                                    borderRadius: '4px',
                                    resize: 'vertical',
                                    fontSize: '14px',
                                    fontFamily: 'inherit',
                                    fontSize: '12px',
                                  }}
                                  placeholder={language === "English" ? "Enter remarks..." : "शेरे टाका..."}
                                />
                              </div>
                            </div>
                          </div>


                        </div>
                      </div>
                    )}

                    <div className="grad d-flex justify-content-between mt-2">
                      <div className="d-flex align-items-end justify-content-center text-center" style={{ width: "23%" }}>
                        <p className="border-top pt-1 mb-0" style={{ fontSize: "11px", color: "#000" }}>
                          {language === "English" ? "Parent's Sign" : "पालकांची स्वाक्षरी"}
                        </p>

                      </div>
                      <div className="d-flex align-items-end justify-content-center text-center" style={{ width: "33%" }}>
                        <p className="border-top pt-1 mb-0" style={{ fontSize: "11px", color: "#000" }}>
                          {language === "English" ? "Class Teacher Sign" : "वर्ग शिक्षक"}
                        </p>
                      </div>
                      <div className="d-flex align-items-end justify-content-center text-center" style={{ width: "33%" }}>
                        <p className="border-top pt-1 mb-0" style={{ fontSize: "11px", color: "#000" }}>
                          {language === "English" ? "Principal Sign" : "मुख्याध्यापक"}
                        </p>
                      </div>
                    </div>
                  </div>



                </div>

              </div>

            ) : (


              <div>
                {/* First semester modal content */}
                <div className="container mt-1" style={{ background: '#dff9fc' }}>
                  <div className="left"  >
                    <div className="left-box" style={{ border: '1px solid black', paddingBottom: '0px' }}>
                      <div style={{ marginBottom: '10px', position: 'relative', minHeight: '150px' }}>
                        {/* Logo and Name Row */}
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '15px',
                            marginBottom: '10px',
                          }}
                        >
                          {schoolLogo && (
                            <div>
                              <img
                                src={schoolLogo}
                                alt="Logo"
                                style={{
                                  width: '100px',
                                  height: '100px',
                                  objectFit: 'cover',
                                }}
                              />
                            </div>
                          )}

                          {/* Name Container */}
                          <div>
                            <h3
                              style={{
                                fontSize: '12px',
                                margin: 0,
                                fontWeight: 'normal',
                              }}
                            >
                              {sansthaName}
                            </h3>
                            <h2
                              style={{
                                fontSize: '18px',
                                fontWeight: 'bold',
                                margin: 0,
                              }}
                            >
                              {schoolName}
                            </h2>
                          </div>
                        </div>


                        {/* Address Information Row - Centered at Bottom of Container */}
                        <div
                          style={{
                            position: 'absolute',
                            bottom: '0',
                            left: '50%',
                            transform: 'translateX(-50%)',
                            fontSize: '12px',
                            color: 'black',
                            whiteSpace: 'nowrap',
                            textAlign: 'center',
                            width: '100%',
                            paddingBottom: '0',
                          }}
                        >
                          <span>
                            {taluka && jilha && (
                              <>
                                {language === 'English' ? 'Tal: ' : 'तालुका :'} {taluka},{' '}
                                {language === 'English' ? 'Dist: ' : 'जिल्हा :'} {jilha},{' '}
                              </>
                            )}
                            {mobileNumber && (
                              <>
                                {language === 'English' ? 'Mob: ' : 'फोन नं. :'} {mobileNumber},{' '}
                              </>
                            )}
                            {udiseNumber && (
                              <>
                                {language === 'English' ? 'UDISE: ' : 'UDISE:'} {udiseNumber}{' '}
                              </>
                            )}
                          </span>
                        </div>
                      </div>
                    </div>
                    <br />

                    <div
                      className="student-info-grid"
                      style={{
                        border: '1px solid black',
                        padding: '4px',
                        fontSize: '14px',
                        lineHeight: '1.2',
                        marginBottom: '10px',
                        padding: '15px'
                      }}
                    >
                      {/* Name in single line */}
                      <p style={{ gridColumn: '1 / span 2', margin: '1px 0' }}>
                        <label style={{ marginRight: '4px', fontSize: '14px' }}>{language === "English" ? "Name :" : "नाव :"}</label>
                        <span>
                          {`${selectedStudentResults?.studentInfo?.name || ''} ${selectedStudentResults?.studentInfo?.father || ''} ${selectedStudentResults?.studentInfo?.surname || ''}`}
                        </span>

                      </p>

                      {/* Roll No on its own line */}
                      <p style={{ margin: '1px 0' }}>
                        <label style={{ marginRight: '4px', fontSize: '14px' }}>{language === "English" ? "Roll No :" : "हजेरी क्र. :"}</label>
                        <span>{selectedStudentResults?.studentInfo?.rollNo || ' '}</span>
                      </p>

                      {/* Rest of the fields in 2-column layout */}
                      <p style={{ margin: '1px 0' }}>
                        <label style={{ marginRight: '4px', fontSize: '14px' }}>{language === "English" ? "Exam :" : "परीक्षा सत्र :"}</label>
                        <span>{selectedExamName || ' '}</span>
                      </p>
                      <p style={{ margin: '1px 0' }}>
                        <label style={{ marginRight: '4px', fontSize: '14px' }}>{language === "English" ? "Year :" : "वर्ष :"}</label>
                        <span>{academicYear || ' '}</span>
                      </p>
                      <p style={{ margin: '1px 0' }}>
                        <label style={{ marginRight: '4px', fontSize: '14px' }}>{language === "English" ? "Class :" : "वर्ग :"}</label>
                        <span>{selectedStudentResults?.studentInfo?.class || ' '}</span>
                      </p>
                      <p style={{ margin: '1px 0' }}>
                        <label style={{ marginRight: '4px', fontSize: '14px' }}>{language === "English" ? "Mother's Name :" : "आईचे नाव :"}</label>
                        <span>{selectedStudentResults?.studentInfo?.stdMother || ''}</span>
                      </p>
                      <p style={{ margin: '1px 0' }}>
                        <label style={{ marginRight: '4px', fontSize: '14px' }}>{language === "English" ? "DOB :" : "जन्मतारीख :"}</label>
                        <span>{selectedStudentResults?.studentInfo?.dob || ' '}</span>
                      </p>
                      <p style={{ margin: '1px 0' }}>
                        <label style={{ marginRight: '4px', fontSize: '14px' }}>{language === "English" ? "Division :" : "तुकडी :"}</label>
                        <span>{selectedStudentResults?.studentInfo?.division || ' '}</span>
                      </p>
                      <p style={{ margin: '1px 0' }}>
                        <label style={{ marginRight: '4px', fontSize: '14px' }}>{language === "English" ? "Mother Tongue :" : "मातृभाषा :"}</label>
                        <span>{selectedStudentResults?.studentInfo?.motherTounge || ' '}</span>
                      </p>
                      <p style={{ margin: '1px 0' }}>
                        <label style={{ marginRight: '4px', fontSize: '14px' }}>{language === "English" ? "Student ID :" : "विद्यार्थी आयडी :"}</label>
                        <span>{selectedStudentResults?.studentInfo?.studentId || ' '}</span>
                      </p>
                      <p style={{ margin: '1px 0' }}>
                        <label style={{ marginRight: '4px', fontSize: '14px' }}>{language === "English" ? "Gender :" : "लिंग :"}</label>
                        <span>{selectedStudentResults?.studentInfo?.gender || ' '}</span>
                      </p>
                    </div>


                    <table className="attendance-table" style={{ backgroundColor: 'white' }}>
                      <thead >
                        <tr>
                          <th >{language === "English" ? "Type:" : "प्रकार"}</th>
                          {firstSemesterMonths.map((month, index) => (
                            <th key={index}>{getMonthName(month)}</th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {['Present', 'Absent', 'Leave'].map((type) => (
                          <tr key={type}>
                            <td>{getAttendanceType(type)}</td>
                            {firstSemesterMonths.map((month, index) => (
                              <td key={index}>
                                <input
                                  type="text"
                                  value={type === 'Leave' && attendance[type][month] < 0 ? '' : attendance[type][month] || ''}

                                />
                              </td>
                            ))}
                          </tr>
                        ))}
                      </tbody>
                    </table>



                    <div className="gradable">
                      <table>
                        <thead>
                          <tr>
                            <th rowSpan="2"></th>
                            <th colSpan="1">{language === "English" ? "First Semester" : "प्रथम सत्र"}</th>
                            <th colSpan="1">{language === "English" ? "Second Semester" : "द्वितीय सत्र"}</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr style={{ backgroundColor: 'white' }}>
                            <td>{language === "English" ? "Weight" : "वजन"} (Kg)</td>
                            <td>{selectedStudentResults?.studentInfo?.weightSeptember || '-'}</td>
                            <td>{selectedStudentResults?.studentInfo?.weightMarch || '-'}</td>
                          </tr>
                          <tr style={{ backgroundColor: 'white' }}>
                            <td>{language === "English" ? "Height" : "उंची"} (Cm)</td>
                            <td>{selectedStudentResults?.studentInfo?.heightSeptember || '-'}</td>
                            <td>{selectedStudentResults?.studentInfo?.heightMarch || '-'}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <div className="right" style={{ padding: '5px', background: '#dff9fc' }}>
                    <div style={{
                      backgroundImage: `url(${resultTermFirst})`,
                      backgroundSize: 'cover',        // or 'contain'
                      backgroundRepeat: 'no-repeat',
                      backgroundPosition: 'center',
                      fontSize: '14px',
                      fontWeight: 'bold',
                      border: '1px solid #000000',
                      height: '120px',
                      marginBottom: '5px'
                    }}
                    >
                    </div>
                    {selectedStudentResults && (
                      <div style={{ fontSize: "13px" }}>
                        <div>
                          <table style={{ borderRadius: '15px', overflow: 'hidden', border: '2px solid #000000', borderCollapse: 'separate', borderBottomLeftRadius: '0', borderBottomRightRadius: '0', borderBottom: 'none' }}>
                            <thead>
                              <tr>
                                <th style={{ width: '30px', border: '1px solid #000000', backgroundColor: '#dff9fc' }} rowSpan="2">{language === "English" ? "Sr." : "क्र."}</th>
                                <th style={{ width: '520px', border: '1px solid #000000', background: '#dff9fc' }} rowSpan="2">{language === "English" ? "Subject" : "विषय"}</th>
                                <th style={{ width: '80px', border: '1px solid #000000', background: '#dff9fc' }}>{language === "English" ? "UT.1" : "युनिट-1"}</th>
                                <th style={{ width: '80px', border: '1px solid #000000', background: '#dff9fc' }}>{language === "English" ? "UT.2" : "युनिट-2"}</th>
                                <th style={{ width: '80px', border: '1px solid #000000', background: '#dff9fc' }}>{language === "English" ? "UT.3" : "युनिट-3"}</th>
                                <th style={{ width: '80px', border: '1px solid #000000', backgroundColor: '#dff9fc' }}>{language === "English" ? "MOY" : "MOY"}</th>
                                <th style={{
                                  width: '180px',
                                  minWidth: '180px',
                                  wordBreak: 'break-word'
                                  , border: '1px solid #000000'
                                  , backgroundColor: '#dff9fc'
                                }} rowSpan="2">
                                  {language === "English" ? "Descriptive Record" : "वर्णनात्मक नोंद"}
                                </th>


                              </tr>
                            </thead>
                            <tbody>
                              {subjectSequence
                                .filter(subject => typeof subject === 'string' && subject.trim() !== '')
                                .map((subject, index) => (
                                  <tr key={index} style={{
                                    height: '24px',  // Reduced row height
                                    lineHeight: '24px'  // Matches height for vertical centering
                                    , border: '1px solid #000000'
                                  }}>
                                    <td style={{
                                      padding: '0 4px',  // Top/bottom: 0, Left/right: 4px
                                      textAlign: 'center'
                                      , border: '1px solid #000000'
                                    }}>{index + 1}</td>
                                    <td style={{
                                      padding: '0 4px'  // Top/bottom: 0, Left/right: 4px
                                      , border: '1px solid #000000',
                                      alignItems: 'left',
                                    }}>{subject}</td>
                                    <td style={{
                                      padding: '0 4px',  // Top/bottom: 0, Left/right: 4px
                                      textAlign: 'center'
                                      , border: '1px solid #000000'
                                    }}>{getSubjectMarkOrGrade(subject, 'unitTestI')}</td>
                                    <td style={{
                                      padding: '0 4px',  // Top/bottom: 0, Left/right: 4px
                                      textAlign: 'center'
                                      , border: '1px solid #000000'
                                    }}>{getSubjectMarkOrGrade(subject, 'unitTestII')}</td>
                                    <td style={{
                                      padding: '0 4px',  // Top/bottom: 0, Left/right: 4px
                                      textAlign: 'center'
                                      , border: '1px solid #000000'
                                    }}>{getSubjectMarkOrGrade(subject, 'unitTestIII')}</td>
                                    <td style={{
                                      padding: '0 4px',  // Top/bottom: 0, Left/right: 4px
                                      textAlign: 'center'
                                      , border: '1px solid #000000'
                                    }}>{getSubjectMarkOrGrade(subject, 'semester')}</td>
                                    {index === 0 && (
                                      <td
                                        rowSpan={subjectSequence.filter(subject => typeof subject === 'string' && subject.trim() !== '').length + 1}
                                        style={{
                                          verticalAlign: "top",
                                          fontSize: "12px",
                                          padding: "6px",
                                          lineHeight: '1.3',
                                          border: '1px solid #000000',
                                          height: 'auto' // Let it expand naturally
                                        }}
                                      >
                                        {/* <td rowSpan="11" style={{ verticalAlign: "top", fontSize: "12px", padding: "2px" }}> */}


                                        <strong >{language === "English" ? "English Oral Skills:" : "मौखिक कौशल्ये:"}</strong>
                                        <ul style={{
                                          listStyleType: 'none',
                                          paddingLeft: 0,
                                          marginBottom: 0,
                                          width: '100%'  // Ensure full width
                                        }}>
                                          <li className="oral-skills-item" style={{
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'center',
                                            marginBottom: '4px'
                                          }}>
                                            <span>- Conversation:</span>
                                            <input
                                              className="oral-skills-input"
                                              type="text"
                                              value={oralSkillsGrades.english.conversation1}
                                              onChange={(e) => handleGradeChange('english', 'conversation1', e.target.value)}
                                              style={{
                                                width: '50px',
                                                marginLeft: '10px',
                                                textAlign: 'center'
                                              }}
                                            />
                                          </li>
                                          <li className="oral-skills-item" style={{
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'center',
                                            marginBottom: '4px'
                                          }}>
                                            <span>- Expresses ideas:</span>
                                            <input
                                              className="oral-skills-input"
                                              type="text"
                                              value={oralSkillsGrades.english.expressesIdeas1}
                                              onChange={(e) => handleGradeChange('english', 'expressesIdeas1', e.target.value)}
                                              style={{
                                                width: '50px',
                                                marginLeft: '10px',
                                                textAlign: 'center'
                                              }}
                                            />
                                          </li>
                                          <li className="oral-skills-item" style={{
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'center'
                                          }}>
                                            <span>- Reading:</span>
                                            <input
                                              className="oral-skills-input"
                                              type="text"
                                              value={oralSkillsGrades.english.reading1}
                                              onChange={(e) => handleGradeChange('english', 'reading1', e.target.value)}
                                              style={{
                                                width: '50px',
                                                marginLeft: '10px',
                                                textAlign: 'center'
                                              }}
                                            />
                                          </li>
                                        </ul>

                                        <strong>{language === "English" ? "Marathi Oral Skills:" : "मौखिक कौशल्ये:"}</strong>
                                        <ul style={{
                                          listStyleType: 'none',
                                          paddingLeft: 0,
                                          marginBottom: 0,
                                          width: '100%'  // Ensure full width
                                        }} >
                                          <li className="oral-skills-item" style={{
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'center',
                                            marginBottom: '4px'
                                          }}>
                                            <span> - Conversation: </span>
                                            <input
                                              className="oral-skills-input"
                                              type="text"
                                              value={oralSkillsGrades.marathi.conversation1}
                                              onChange={(e) => handleGradeChange('marathi', 'conversation1', e.target.value)}
                                              style={{
                                                width: '50px',
                                                marginLeft: '10px',
                                                textAlign: 'center'
                                              }}
                                            />
                                          </li>
                                          <li className="oral-skills-item" style={{
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'center',
                                            marginBottom: '4px'
                                          }}>
                                            <span>- Reading:</span>
                                            <input
                                              className="oral-skills-input"
                                              type="text"
                                              value={oralSkillsGrades.marathi.reading1}
                                              onChange={(e) => handleGradeChange('marathi', 'reading1', e.target.value)}
                                              style={{
                                                width: '50px',
                                                marginLeft: '10px',
                                                textAlign: 'center'
                                              }}
                                            />
                                          </li>
                                          <li className="oral-skills-item" style={{
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'center',
                                            marginBottom: '4px'
                                          }}>
                                            <span>- Recitation:</span>
                                            <input
                                              className="oral-skills-input"
                                              type="text"
                                              value={oralSkillsGrades.marathi.recitation1}
                                              onChange={(e) => handleGradeChange('marathi', 'recitation1', e.target.value)}
                                              style={{
                                                width: '50px',
                                                marginLeft: '10px',
                                                textAlign: 'center'
                                              }}
                                            />
                                          </li>
                                        </ul>

                                        <strong>{language === "English" ? "Maths Oral Skills:" : "मौखिक कौशल्ये:"}</strong>
                                        <ul style={{
                                          listStyleType: 'none',
                                          paddingLeft: 0,
                                          marginBottom: 0,
                                          width: '100%'  // Ensure full width
                                        }}>
                                          <li className="oral-skills-item" style={{
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'center'
                                          }}>
                                            <span>- Clarity Of Concept: </span>
                                            <input
                                              className="oral-skills-input"
                                              type="text"
                                              value={oralSkillsGrades.maths.clarityOfConcept1}
                                              onChange={(e) => handleGradeChange('maths', 'clarityOfConcept1', e.target.value)}
                                              style={{
                                                width: '50px',
                                                marginLeft: '10px',
                                                textAlign: 'center'
                                              }}
                                            />
                                          </li>
                                          <li className="oral-skills-item"
                                            style={{
                                              display: 'flex',
                                              justifyContent: 'space-between',
                                              alignItems: 'center', // center vertically
                                              padding: '4px 0'
                                            }}
                                          >
                                            <span style={{ flex: 1, textAlign: 'left' }}>
                                              - Recognition & Counting:
                                            </span>
                                            <input
                                              className="oral-skills-input"
                                              type="text"
                                              value={oralSkillsGrades.maths.recognitionCounting1}
                                              onChange={(e) => handleGradeChange('maths', 'recognitionCounting1', e.target.value)}
                                              style={{
                                                width: '50px',
                                                textAlign: 'center'
                                              }}
                                            />
                                          </li>

                                          <li className="oral-skills-item" style={{
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'center'
                                          }}>
                                            <span> - Number Formation: </span>
                                            <input
                                              className="oral-skills-input"
                                              type="text"
                                              value={oralSkillsGrades.maths.numberFormation1}
                                              onChange={(e) => handleGradeChange('maths', 'numberFormation1', e.target.value)}
                                              style={{
                                                width: '50px',
                                                marginLeft: '10px',
                                                textAlign: 'center'
                                              }}
                                            />
                                          </li>
                                        </ul>

                                        <strong>{language === "English" ? "EVS Oral Skills:" : "मौखिक कौशल्ये:"}</strong>
                                        <ul style={{
                                          listStyleType: 'none',
                                          paddingLeft: 0,
                                          marginBottom: 0,
                                          width: '100%'  // Ensure full width
                                        }}>
                                          <li className="oral-skills-item" style={{
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'center',
                                            marginBottom: '4px'
                                          }}>
                                            <span>  - General Awareness: </span>
                                            <input
                                              className="oral-skills-input"
                                              type="text"
                                              value={oralSkillsGrades.evs.generalAwareness1}
                                              onChange={(e) => handleGradeChange('evs', 'generalAwareness1', e.target.value)}
                                              style={{
                                                width: '50px',
                                                marginLeft: '10px',
                                                textAlign: 'center'
                                              }} />
                                          </li>
                                          <li className="oral-skills-item" style={{
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'center',
                                            marginBottom: '4px'
                                          }}>
                                            - My Self:
                                            <input
                                              className="oral-skills-input"
                                              type="text"
                                              value={oralSkillsGrades.evs.mySelf1}
                                              onChange={(e) => handleGradeChange('evs', 'mySelf1', e.target.value)}
                                              style={{
                                                width: '50px',
                                                marginLeft: '10px',
                                                textAlign: 'center'
                                              }} />
                                          </li>
                                          <li className="oral-skills-item" style={{
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'center',
                                            marginBottom: '4px'
                                          }}>
                                            - About Animals:
                                            <input
                                              className="oral-skills-input"
                                              type="text"
                                              value={oralSkillsGrades.evs.aboutAnimals1}
                                              onChange={(e) => handleGradeChange('evs', 'aboutAnimals1', e.target.value)}
                                              style={{
                                                width: '50px',
                                                marginLeft: '10px',
                                                textAlign: 'center'
                                              }} />
                                          </li>
                                          <li className="oral-skills-item" style={{
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'center',
                                            marginBottom: '4px'
                                          }}>
                                            - Internal Body Parts:
                                            <input
                                              className="oral-skills-input"
                                              type="text"
                                              value={oralSkillsGrades.evs.internalBodyParts1}
                                              onChange={(e) => handleGradeChange('evs', 'internalBodyParts1', e.target.value)}
                                              style={{
                                                width: '50px',
                                                marginLeft: '10px',
                                                textAlign: 'center'
                                              }} />
                                          </li>
                                        </ul>
                                      </td>
                                    )}
                                  </tr>
                                ))}
                              {/* Personality Development Row */}
                              <tr className="personality-development">
                                <td colSpan="6" className="p-2" style={{ border: '1px solid #000000' }}>
                                  <h6 className="mb-1">
                                    <strong>{language === "English" ? "PERSONALITY DEVELOPMENT" : "व्यक्तिमत्व विकास"}</strong>
                                  </h6>
                                  <ul className="list-unstyled mb-0" style={{ fontSize: "12px" }}>
                                    <li className="oral-skills-item" style={{
                                      display: 'flex',
                                      justifyContent: 'space-between',
                                      alignItems: 'center',
                                      marginBottom: '4px',
                                    }}>
                                      - {language === "English" ? "Exhibits self control" : "स्वतःवर नियंत्रण ठेवते"}:
                                      <input
                                        className="oral-skills-input"
                                        type="text"
                                        value={oralSkillsGrades.personality.selfControl1}
                                        onChange={(e) => handleGradeChange('personality', 'selfControl1', e.target.value)}
                                        style={{
                                          width: '50px',
                                          marginLeft: '10px',
                                          textAlign: 'center'
                                        }} />
                                    </li>
                                    <li className="oral-skills-item" style={{
                                      display: 'flex',
                                      justifyContent: 'space-between',
                                      alignItems: 'center',
                                      marginBottom: '4px'
                                    }}>
                                      - {language === "English" ? "Respects Others" : "इतरांचा आदर करते"}:
                                      <input
                                        className="oral-skills-input"
                                        type="text"
                                        value={oralSkillsGrades.personality.respectsOthers1}
                                        onChange={(e) => handleGradeChange('personality', 'respectsOthers1', e.target.value)}
                                        style={{
                                          width: '50px',
                                          marginLeft: '10px',
                                          textAlign: 'center'
                                        }} />
                                    </li>
                                    <li className="oral-skills-item" style={{
                                      display: 'flex',
                                      justifyContent: 'space-between',
                                      alignItems: 'center',
                                      marginBottom: '4px'
                                    }}>
                                      - {language === "English" ? "Neatness & Cleanliness" : "स्वच्छता आणि सफाई"}:
                                      <input
                                        className="oral-skills-input"
                                        type="text"
                                        value={oralSkillsGrades.personality.neatnessCleanliness1}
                                        onChange={(e) => handleGradeChange('personality', 'neatnessCleanliness1', e.target.value)}
                                        style={{
                                          width: '50px',
                                          marginLeft: '10px',
                                          textAlign: 'center'
                                        }} />
                                    </li>
                                    <li className="oral-skills-item" style={{
                                      display: 'flex',
                                      justifyContent: 'space-between',
                                      alignItems: 'center',
                                      marginBottom: '4px'
                                    }}>
                                      - {language === "English" ? "Obeying Teachers" : "शिक्षकांचे आज्ञापालन"}:
                                      <input
                                        className="oral-skills-input"
                                        type="text"
                                        value={oralSkillsGrades.personality.obeyingTeachers1}
                                        onChange={(e) => handleGradeChange('personality', 'obeyingTeachers1', e.target.value)}
                                        style={{
                                          width: '50px',
                                          marginLeft: '10px',
                                          textAlign: 'center'
                                        }} />
                                    </li>
                                  </ul>
                                </td>
                              </tr>
                            </tbody>

                          </table>



                          {/* Conducts and Remarks Section */}
                          <div
                            style={{
                              marginTop: '0px',
                              border: '2px solid #000000',
                              borderRadius: '15px',
                              padding: '5px',
                              backgroundColor: '#dff9fc',
                              boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                              borderTopLeftRadius: '0',
                              borderTopRightRadius: '0',
                              borderTop: 'none',
                            }}
                          >
                            {/* Conducts */}
                            <div style={{ marginBottom: '16px' }}>
                              <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '12px'
                              }}>
                                <h6 style={{
                                  margin: 0,
                                  minWidth: '120px',
                                  fontSize: '14px',
                                  fontWeight: '600',
                                  color: '#333',
                                  fontSize: '12px',
                                }}>
                                  {language === "English" ? "Conducts" : "वर्तन"}
                                </h6>
                                <input
                                  value={oralSkillsGrades.extra.conducts1}
                                  onChange={(e) => handleGradeChange('extra', 'conducts1', e.target.value)}
                                  style={{
                                    flex: 1,
                                    maxHeight: '80px',
                                    padding: '4px',
                                    border: '1px solid #ccc',
                                    borderRadius: '4px',
                                    resize: 'vertical',
                                    fontSize: '14px',
                                    fontFamily: 'inherit',
                                    fontSize: '12px',
                                  }}
                                  placeholder={language === "English" ? "Enter conducts..." : "वर्तन टाका..."}
                                />
                              </div>
                            </div>

                            {/* Teacher's Remarks */}
                            <div>
                              <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '12px'
                              }}>
                                <h6 style={{
                                  margin: 0,
                                  minWidth: '120px',
                                  fontSize: '12px',
                                  fontWeight: '600',
                                  color: '#333'
                                }}>
                                  {language === "English" ? "Teacher's Remarks" : "शिक्षकांचे शेरे"}
                                </h6>
                                <input
                                  value={oralSkillsGrades.extra.teacherRemarks1}
                                  onChange={(e) => handleGradeChange('extra', 'teacherRemarks1', e.target.value)}
                                  style={{
                                    flex: 1,
                                    maxHeight: '80px',
                                    padding: '4px',
                                    border: '1px solid #ccc',
                                    borderRadius: '4px',
                                    resize: 'vertical',
                                    fontSize: '14px',
                                    fontFamily: 'inherit',
                                    fontSize: '12px',
                                  }}
                                  placeholder={language === "English" ? "Enter remarks..." : "शेरे टाका..."}
                                />
                              </div>
                            </div>
                          </div>

                        </div>
                      </div>
                    )}
                    <div className="grad d-flex justify-content-between mt-2">
                      <div className="d-flex align-items-end justify-content-center text-center" style={{ width: "23%" }}>
                        <p className="border-top pt-1 mb-0" style={{ fontSize: "11px", color: "#000" }}>
                          {language === "English" ? "Parent's Sign" : "पालकांची स्वाक्षरी"}
                        </p>

                      </div>
                      <div className="d-flex align-items-end justify-content-center text-center" style={{ width: "33%" }}>
                        <p className="border-top pt-1 mb-0" style={{ fontSize: "11px", color: "#000" }}>
                          {language === "English" ? "Class Teacher Sign" : "वर्ग शिक्षक"}
                        </p>
                      </div>
                      <div className="d-flex align-items-end justify-content-center text-center" style={{ width: "33%" }}>
                        <p className="border-top pt-1 mb-0" style={{ fontSize: "11px", color: "#000" }}>
                          {language === "English" ? "Principal Sign" : "मुख्याध्यापक"}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseModal}>
              {language === "English" ? " Close " : "Close करा"}
            </Button>


            <Button
              onClick={saveGrades}
              className="btn btn-primary"
              style={{ padding: '5px 15px', fontSize: '12px' }}
            >
              {language === "English" ? "Save Grades" : "गुण जतन करा"}
            </Button>


            <Button variant="primary" onClick={handlePrint}>
              {language === "English" ? "Print" : "Print करा"}
            </Button>

          </Modal.Footer>
        </Modal>

      </div>
    </div>
  );
};

export default CbseResult;
